export default {
    "en": {
        "aiBackgroundChanger": {
            "title": "Free AI Image Background Changer Online | WeryAI",
            "description": "Change image backgrounds instantly -- pick a solid color or describe a new scene with AI. Perfect for product photos and profiles. Free credits, no card needed.",
            "keywords": "ai image background changer, ai background changer, change image background, change photo background, solid color background, white background maker, replace background online",
            "og_title": "Free AI Image Background Changer Online | WeryAI",
            "og_description": "Change image backgrounds instantly -- pick a solid color or describe a new scene with AI. Perfect for product photos and profiles. Free credits, no card needed.",
            "twitter_title": "Free AI Image Background Changer Online | WeryAI",
            "twitter_description": "Change image backgrounds instantly -- pick a solid color or describe a new scene with AI. Perfect for product photos and profiles. Free credits, no card needed.",
            "page": {
                "title1": "Free AI Image Background Changer",
                "title2": "Upload a photo and choose how you want to replace the background. Pick a solid color for clean product or profile images, or enter a prompt to generate a brand-new scene around your subject.",
                "faq": [
                    {
                        "question": "How do I change a photo background with AI?",
                        "answer": "Upload your image, then choose one background mode. Pick a solid color if you want a clean plain background, or enter a scene prompt if you want AI to generate a new environment. Click Create to process it. Need to remove the background entirely? Try our <a href=\"/ai-image-background-remover\">Image Background Remover</a>."
                    },
                    {
                        "question": "Can I make the background plain white or another solid color?",
                        "answer": "Yes. Use the color picker to choose white, black, or any custom HEX color. This works well for product listings, profile photos, and other clean studio-style outputs."
                    },
                    {
                        "question": "Can I generate a new background from text?",
                        "answer": "Yes. Type the scene you want, such as a marble studio, office desk, cafe corner, or beach at sunset, and AI will replace the original background with a new scene around your subject."
                    },
                    {
                        "question": "When should I use color mode instead of prompt mode?",
                        "answer": "Use color mode when you need standardized outputs like white backgrounds, brand-color backdrops, or simple profile photos. Use prompt mode when you want lifestyle, marketing, or creative scene backgrounds."
                    },
                    {
                        "question": "Can I use AI Image Background Changer for free?",
                        "answer": "Yes. WeryAI gives new users free credits on sign-up with no credit card required. You can also keep getting free credits through daily check-ins, completing tasks, and inviting friends, so you can continue using the tool without paying upfront."
                    }
                ]
            },
            "faq": [
                {
                    "question": "How do I change a photo background with AI?",
                    "answer": "Upload your image, then choose one background mode. Pick a solid color if you want a clean plain background, or enter a scene prompt if you want AI to generate a new environment. Click Create to process it."
                },
                {
                    "question": "Can I make the background plain white or another solid color?",
                    "answer": "Yes. Use the color picker to choose white, black, or any custom HEX color. This works well for product listings, profile photos, and other clean studio-style outputs."
                },
                {
                    "question": "Can I generate a new background from text?",
                    "answer": "Yes. Type the scene you want, such as a marble studio, office desk, cafe corner, or beach at sunset, and AI will replace the original background with a new scene around your subject."
                },
                {
                    "question": "When should I use color mode instead of prompt mode?",
                    "answer": "Use color mode when you need standardized outputs like white backgrounds, brand-color backdrops, or simple profile photos. Use prompt mode when you want lifestyle, marketing, or creative scene backgrounds."
                },
                {
                    "question": "Can I use AI Image Background Changer for free?",
                    "answer": "Yes. WeryAI gives new users free credits on sign-up with no credit card required. You can also keep getting free credits through daily check-ins, completing tasks, and inviting friends, so you can continue using the tool without paying upfront."
                }
            ],
            "feature_title1": "Solid Color Backgrounds for Products & Headshots",
            "feature_desc1": "Need a clean white background, a black backdrop, or a brand color? Choose a solid color to turn cluttered photos into simple, standardized images for e-commerce, resumes, and profile use.",
            "feature_title2": "Prompt-Based Scene Replacement",
            "feature_desc2": "Describe the scene you want, like a marble studio, office workspace, or cozy cafe, and AI will generate a new background around your subject in seconds.",
            "feature_title3": "Natural Subject Preservation",
            "feature_desc3": "WeryAI is built to keep the main person, pet, or product visually clear, so your result still looks focused and usable after the background changes.",
            "howto": {
                "name": "How to Change Photo Background with AI",
                "step1": {
                    "name": "Upload Image",
                    "text": "Upload a clear product, portrait, or pet photo to WeryAI."
                },
                "step2": {
                    "name": "Choose Color or Prompt",
                    "text": "Pick a solid background color, or type a prompt for a new scene. Use one mode at a time."
                },
                "step3": {
                    "name": "Generate",
                    "text": "Click 'Create'. AI keeps the subject and replaces the original background in seconds."
                }
            }
        }
    },
    "zh": {
        "aiBackgroundChanger": {
            "title": "免费 AI 图片背景更换器 - 纯色背景或场景换背景 | WeryAI",
            "description": "在线用 AI 更换图片背景。可手动选择纯色背景，快速制作白底商品图和证件照；也可输入提示词，把背景替换成办公室、影棚、咖啡馆、海边等任意场景。",
            "keywords": "AI 图片背景更换器, 更换照片背景, 图片换背景, 纯色背景, 白底商品图, 证件照换背景, 在线替换背景, 场景背景生成",
            "og_title": "免费 AI 图片背景更换器 - 纯色背景或场景换背景 | WeryAI",
            "og_description": "在线用 AI 更换图片背景。可手动选择纯色背景，快速制作白底商品图和证件照；也可输入提示词，把背景替换成办公室、影棚、咖啡馆、海边等任意场景。",
            "twitter_title": "免费 AI 图片背景更换器 - 纯色背景或场景换背景 | WeryAI",
            "twitter_description": "在线用 AI 更换图片背景。可手动选择纯色背景，快速制作白底商品图和证件照；也可输入提示词，把背景替换成办公室、影棚、咖啡馆、海边等任意场景。",
            "page": {
                "title1": "免费 AI 图片背景更换器",
                "title2": "上传一张图片后，你可以选择两种背景更换方式：手动选择背景颜色，快速生成干净统一的纯色背景；或输入提示词，把原背景替换成办公室、影棚、咖啡馆、海边等任意新场景。",
                "faq": [
                    {
                        "question": "如何用 AI 更换图片背景？",
                        "answer": "上传图片后，选择一种背景模式即可：想要纯色背景就直接选颜色，想要新场景就输入提示词。点击“创建”后，AI 会自动保留主体并替换原背景。"
                    },
                    {
                        "question": "可以换成纯白或其他纯色背景吗？",
                        "answer": "可以。使用颜色选择器即可快速切换成白色、黑色或自定义 HEX 纯色背景，非常适合商品主图、证件照和品牌统一素材。"
                    },
                    {
                        "question": "可以通过提示词生成新的场景背景吗？",
                        "answer": "可以。你可以输入“大理石影棚”“办公室桌面”“咖啡馆角落”“海边日落”等场景描述，AI 会围绕主体生成新的背景环境。"
                    },
                    {
                        "question": "什么时候该用颜色模式，什么时候该用提示词模式？",
                        "answer": "如果你需要白底图、品牌色背景或标准化头像，优先用颜色模式；如果你想做营销海报、生活方式场景图或创意内容，就用提示词模式。"
                    },
                    {
                        "question": "AI 图片背景更换器可以免费使用吗？",
                        "answer": "可以。新用户注册即可获得免费积分，无需信用卡。之后还可以通过每日签到、完成任务和邀请好友持续获得免费积分，因此无需预付费也能继续使用图片背景更换器。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "如何用 AI 更换图片背景？",
                    "answer": "上传图片后，选择一种背景模式即可：想要纯色背景就直接选颜色，想要新场景就输入提示词。点击“创建”后，AI 会自动保留主体并替换原背景。"
                },
                {
                    "question": "可以换成纯白或其他纯色背景吗？",
                    "answer": "可以。使用颜色选择器即可快速切换成白色、黑色或自定义 HEX 纯色背景，非常适合商品主图、证件照和品牌统一素材。"
                },
                {
                    "question": "可以通过提示词生成新的场景背景吗？",
                    "answer": "可以。你可以输入“大理石影棚”“办公室桌面”“咖啡馆角落”“海边日落”等场景描述，AI 会围绕主体生成新的背景环境。"
                },
                {
                    "question": "什么时候该用颜色模式，什么时候该用提示词模式？",
                    "answer": "如果你需要白底图、品牌色背景或标准化头像，优先用颜色模式；如果你想做营销海报、生活方式场景图或创意内容，就用提示词模式。"
                },
                {
                    "question": "AI 图片背景更换器可以免费使用吗？",
                    "answer": "可以。新用户注册即可获得免费积分，无需信用卡。之后还可以通过每日签到、完成任务和邀请好友持续获得免费积分，因此无需预付费也能继续使用图片背景更换器。"
                }
            ],
            "feature_title1": "纯色背景快速出图",
            "feature_desc1": "需要白底图、黑底图或品牌色背景时，直接选择颜色即可把杂乱背景改成干净统一的纯色底，适合商品图、证件照和履历头像。",
            "feature_title2": "提示词换背景，场景更灵活",
            "feature_desc2": "输入你想要的场景，比如大理石影棚、办公室桌面、咖啡馆角落或海边日落，AI 会围绕主体生成新的背景环境。",
            "feature_title3": "主体清晰保留，结果更自然",
            "feature_desc3": "无论是人物、宠物还是商品，WeryAI 都会优先保留主体的视觉重点，让背景替换后的成图依然清晰、自然、可直接使用。",
            "howto": {
                "name": "如何使用 AI 更改照片背景",
                "step1": {
                    "name": "上传图片",
                    "text": "上传一张主体清晰的产品图、人像或宠物图片到 WeryAI。"
                },
                "step2": {
                    "name": "选择颜色或输入提示词",
                    "text": "如果你想要纯色背景，直接选择颜色；如果你想要新的场景背景，就输入提示词。颜色与提示词一次选择一种即可。"
                },
                "step3": {
                    "name": "生成",
                    "text": "点击“创建”，AI 会保留主体并在几秒内替换原背景。"
                }
            }
        }
    },
    "ja": {
        "aiBackgroundChanger": {
            "title": "無料AI画像背景チェンジャー - テキストで背景を生成 | WeryAI",
            "description": "AIで写真の背景を即座に変更。欲しいシーンを言葉で説明するだけで、WeryAIが商品撮影、LinkedInのヘッドショット、クリエイティブなポートレート向けにリアルな背景を生成します。無料・オンライン。",
            "keywords": "写真 背景 変更, AI 背景 生成, 商品撮影 AI, 白背景 作成, オンライン 背景 置換, 生成塗りつぶし 背景",
            "og_title": "無料AI画像背景チェンジャー - テキストで背景を生成 | WeryAI",
            "og_description": "AIで写真の背景を即座に変更。欲しいシーンを言葉で説明するだけで、WeryAIが商品撮影、LinkedInのヘッドショット、クリエイティブなポートレート向けにリアルな背景を生成します。無料・オンライン。",
            "twitter_title": "無料AI画像背景チェンジャー - テキストで背景を生成 | WeryAI",
            "twitter_description": "AIで写真の背景を即座に変更。欲しいシーンを言葉で説明するだけで、WeryAIが商品撮影、LinkedInのヘッドショット、クリエイティブなポートレート向けにリアルな背景を生成します。無料・オンライン。",
            "page": {
                "title1": "無料AI背景チェンジャー＆ジェネレーター",
                "title2": "背景を「消す」だけでなく、もっと良い背景に「置き換え」ましょう。写真をアップロードし、任意のシーン（例：「高級大理石スタジオ」「オフィスのスカイライン」）を説明してください。生成AIが光と遠近感を理解し、被写体を新しい環境に自然に合成します。",
                "faq": [
                    {
                        "question": "テキストで背景を変更するには？",
                        "answer": "画像をアップロードし、「背景プロンプト」欄に欲しいシーン（例：「居心地のいいカフェ」）を入力します。[作成]をクリックするとAIがその背景を生成します。"
                    },
                    {
                        "question": "背景を真っ白にできますか？",
                        "answer": "はい。プロンプトに「純白の背景」または「スタジオホワイト」と入力するだけです。Amazon/eBayの商品画像や証明写真に最適です。"
                    },
                    {
                        "question": "商品撮影に向いていますか？",
                        "answer": "もちろんです。WeryAIは商品の角度を解析し、適切な影と光を持つ背景を生成して、プロのスタジオ撮影のように見せます。"
                    },
                    {
                        "question": "光は自然に見えますか？",
                        "answer": "当社の生成AI（Adobe FireflyやSDXLに近い）は、生成背景の光を被写体に合わせるように試み、違和感なく馴染ませます。"
                    },
                    {
                        "question": "AI画像背景チェンジャーは無料で使えますか？",
                        "answer": "はい。新規ユーザーは登録時にクレジットカード不要で無料クレジットを受け取れます。さらに、毎日のチェックイン、タスク完了、友達招待でも無料クレジットを継続的に獲得できるため、前払いなしで使い続けられます。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "テキストで背景を変更するには？",
                    "answer": "画像をアップロードし、「背景プロンプト」欄に欲しいシーン（例：「居心地のいいカフェ」）を入力します。[作成]をクリックするとAIがその背景を生成します。"
                },
                {
                    "question": "背景を真っ白にできますか？",
                    "answer": "はい。プロンプトに「純白の背景」または「スタジオホワイト」と入力するだけです。Amazon/eBayの商品画像や証明写真に最適です。"
                },
                {
                    "question": "商品撮影に向いていますか？",
                    "answer": "もちろんです。WeryAIは商品の角度を解析し、適切な影と光を持つ背景を生成して、プロのスタジオ撮影のように見せます。"
                },
                {
                    "question": "光は自然に見えますか？",
                    "answer": "当社の生成AI（Adobe FireflyやSDXLに近い）は、生成背景の光を被写体に合わせるように試み、違和感なく馴染ませます。"
                },
                {
                    "question": "AI画像背景チェンジャーは無料で使えますか？",
                    "answer": "はい。新規ユーザーは登録時にクレジットカード不要で無料クレジットを受け取れます。さらに、毎日のチェックイン、タスク完了、友達招待でも無料クレジットを継続的に獲得できるため、前払いなしで使い続けられます。"
                }
            ],
            "feature_title1": "プロ仕様の証明写真・プロフィール写真",
            "feature_desc1": "DIY LinkedInヘッドショット：何気ない自撮りをプロのプロフィール写真に。散らかった部屋の背景を、清潔なオフィスやスタジオグレーに一瞬で変更。",
            "feature_title2": "即席の商品撮影",
            "feature_desc2": "EC売上アップ：撮影費を大幅に節約。木のテーブル、砂浜、台座などにテキストだけで商品を配置。AIがリアルな影や反射を追加します。",
            "feature_title3": "クリエイティブな瞬間移動",
            "feature_desc3": "パリやサイバーパンクの未来へ行きたい？入力するだけ。元の写真の光を保ちながら背景を置き換えます。",
            "howto": {
                "name": "AIで写真の背景を変更する方法",
                "step1": {
                    "name": "画像をアップロード",
                    "text": "WeryAIに写真（商品またはポートレート）をアップロードします。"
                },
                "step2": {
                    "name": "背景を説明",
                    "text": "「背景プロンプト」ボックスに新しいシーンの説明を入力します（例：「大理石のテーブル」）。"
                },
                "step3": {
                    "name": "生成",
                    "text": "「作成」をクリックします。AIが古い背景を削除し、新しい背景をシームレスに生成します。"
                }
            }
        }
    },
    "ko": {
        "aiBackgroundChanger": {
            "title": "무료 AI 이미지 배경 교체기 - 텍스트에서 배경 생성 | WeryAI",
            "description": "AI로 사진 배경을 즉시 변경하세요. 원하는 장면을 설명하면 WeryAI가 제품 사진, LinkedIn 헤드샷 및 창의적인 초상화를 위한 사실적인 배경을 생성합니다. 무료 및 온라인.",
            "keywords": "사진 배경 변경, AI 배경 생성기, 제품 사진 AI, 흰색 배경 제작기, 온라인 배경 교체, 생성 채우기 배경",
            "og_title": "무료 AI 이미지 배경 교체기 - 텍스트에서 배경 생성 | WeryAI",
            "og_description": "AI로 사진 배경을 즉시 변경하세요. 원하는 장면을 설명하면 WeryAI가 제품 사진, LinkedIn 헤드샷 및 창의적인 초상화를 위한 사실적인 배경을 생성합니다. 무료 및 온라인.",
            "twitter_title": "무료 AI 이미지 배경 교체기 - 텍스트에서 배경 생성 | WeryAI",
            "twitter_description": "AI로 사진 배경을 즉시 변경하세요. 원하는 장면을 설명하면 WeryAI가 제품 사진, LinkedIn 헤드샷 및 창의적인 초상화를 위한 사실적인 배경을 생성합니다. 무료 및 온라인.",
            "page": {
                "title1": "무료 AI 배경 교체기 및 생성기",
                "title2": "배경을 제거하는 것이 아니라 더 나은 것으로 교체하세요. 사진을 업로드하고 원하는 장면을 설명하세요(예: \"고급 대리석 스튜디오\", \"오피스 스카이라인\"). 저희 생성 AI는 조명과 원근법을 이해하여 피사체를 새로운 환경에 완벽하게 블렌딩합니다.",
                "faq": [
                    {
                        "question": "텍스트를 사용하여 배경을 변경하는 방법은?",
                        "answer": "이미지를 업로드하고 \"배경 프롬프트\" 상자에 원하는 장면을 설명하세요(예: \"아늑한 커피숍\"). 만들기를 클릭하면 AI가 해당 배경을 생성합니다."
                    },
                    {
                        "question": "배경을 순백색으로 변경할 수 있나요?",
                        "answer": "예. 프롬프트 상자에 \"순수한 흰색 배경\" 또는 \"스튜디오 화이트\"를 입력하기만 하면 됩니다. Amazon/eBay 제품 목록 및 공식 ID 사진에 완벽합니다."
                    },
                    {
                        "question": "제품 사진에 좋은가요?",
                        "answer": "물론입니다. WeryAI는 제품의 각도를 분석하고 올바른 그림자와 조명이 있는 배경을 생성하여 전문 스튜디오 촬영처럼 보이게 합니다."
                    },
                    {
                        "question": "조명이 자연스럽게 보이나요?",
                        "answer": "저희 생성 AI(Adobe Firefly 또는 SDXL과 유사)는 생성된 배경의 조명을 피사체와 일치시키려고 시도하여 매끄럽게 블렌딩합니다."
                    },
                    {
                        "question": "AI 이미지 배경 변경기를 무료로 사용할 수 있나요?",
                        "answer": "예. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해서도 무료 크레딧을 계속 받을 수 있어 선결제 없이도 계속 사용할 수 있습니다."
                    }
                ]
            },
            "faq": [
                {
                    "question": "텍스트를 사용하여 배경을 변경하는 방법은?",
                    "answer": "이미지를 업로드하고 \"배경 프롬프트\" 상자에 원하는 장면을 설명하세요(예: \"아늑한 커피숍\"). 만들기를 클릭하면 AI가 해당 배경을 생성합니다."
                },
                {
                    "question": "배경을 순백색으로 변경할 수 있나요?",
                    "answer": "예. 프롬프트 상자에 \"순수한 흰색 배경\" 또는 \"스튜디오 화이트\"를 입력하기만 하면 됩니다. Amazon/eBay 제품 목록 및 공식 ID 사진에 완벽합니다."
                },
                {
                    "question": "제품 사진에 좋은가요?",
                    "answer": "물론입니다. WeryAI는 제품의 각도를 분석하고 올바른 그림자와 조명이 있는 배경을 생성하여 전문 스튜디오 촬영처럼 보이게 합니다."
                },
                {
                    "question": "조명이 자연스럽게 보이나요?",
                    "answer": "저희 생성 AI(Adobe Firefly 또는 SDXL과 유사)는 생성된 배경의 조명을 피사체와 일치시키려고 시도하여 매끄럽게 블렌딩합니다."
                },
                {
                    "question": "AI 이미지 배경 변경기를 무료로 사용할 수 있나요?",
                    "answer": "예. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해서도 무료 크레딧을 계속 받을 수 있어 선결제 없이도 계속 사용할 수 있습니다."
                }
            ],
            "feature_title1": "전문 ID 사진",
            "feature_desc1": "DIY LinkedIn 헤드샷: 캐주얼한 셀카를 전문 프로필 사진으로 바꾸세요. 지저분한 침실 배경을 깨끗한 사무실 또는 스튜디오 회색 배경으로 즉시 변경합니다.",
            "feature_title2": "즉시 제품 사진",
            "feature_desc2": "전자상거래 판매 증대: 사진 촬영에 수천 달러를 절약하세요. 간단한 텍스트 프롬프트로 제품을 나무 테이블, 모래 해변 또는 연단에 배치하세요. AI가 사실적인 그림자와 반사를 추가합니다.",
            "feature_title3": "창의적 텔레포테이션",
            "feature_desc3": "어디든 여행: 파리나 사이버펑크 미래에 있고 싶으신가요? 입력하기만 하면 됩니다. 저희 AI는 원본 사진의 조명과 일관성을 유지하면서 배경을 교체합니다.",
            "howto": {
                "name": "AI로 사진 배경 변경하는 방법",
                "step1": {
                    "name": "이미지 업로드",
                    "text": "사진(제품 또는 인물)을 WeryAI에 업로드하세요."
                },
                "step2": {
                    "name": "배경 설명",
                    "text": "'배경 프롬프트' 상자에 새로운 장면을 설명하세요(예: '대리석 테이블')."
                },
                "step3": {
                    "name": "생성",
                    "text": "'만들기'를 클릭하세요. AI가 기존 배경을 제거하고 새로운 배경을 자연스럽게 생성합니다."
                }
            }
        }
    },
    "es": {
        "aiBackgroundChanger": {
            "title": "Cambiar Fondo de Imagen con IA Gratis | WeryAI",
            "description": "Cambia el fondo de tus fotos al instante con IA. Describe la escena que quieres y WeryAI generará fondos realistas para fotografía de producto, fotos profesionales tipo LinkedIn y retratos creativos. Gratis y online.",
            "keywords": "cambiar fondo de foto, generador de fondos IA, fotografía de producto IA, fondo blanco, reemplazar fondo online, relleno generativo de fondo",
            "og_title": "Cambiar Fondo de Imagen con IA Gratis | WeryAI",
            "og_description": "Cambia el fondo de tus fotos al instante con IA. Describe la escena que quieres y WeryAI generará fondos realistas para fotografía de producto, fotos profesionales tipo LinkedIn y retratos creativos. Gratis y online.",
            "twitter_title": "Cambiar Fondo de Imagen con IA Gratis | WeryAI",
            "twitter_description": "Cambia el fondo de tus fotos al instante con IA. Describe la escena que quieres y WeryAI generará fondos realistas para fotografía de producto, fotos profesionales tipo LinkedIn y retratos creativos. Gratis y online.",
            "page": {
                "title1": "Cambiador de Fondo IA Gratis y Generador",
                "title2": "No solo elimines el fondo: cámbialo por uno mejor. Sube tu foto y describe cualquier escena (p. ej., \"estudio de mármol de lujo\", \"skyline de oficina\"). Nuestra IA generativa entiende la luz y la perspectiva para integrar tu sujeto perfectamente en el nuevo entorno.",
                "faq": [
                    {
                        "question": "¿Cómo cambio el fondo usando texto?",
                        "answer": "Sube tu imagen y, en el cuadro de \"Prompt de Fondo\", describe la escena que quieres (p. ej., \"una cafetería acogedora\"). Haz clic en Crear y la IA generará ese fondo para ti."
                    },
                    {
                        "question": "¿Puedo cambiar el fondo a blanco liso?",
                        "answer": "Sí. Solo escribe \"fondo blanco puro\" o \"blanco de estudio\" en el prompt. Es perfecto para listados de productos de Amazon/eBay y fotos de identificación."
                    },
                    {
                        "question": "¿Es bueno para fotografía de producto?",
                        "answer": "Totalmente. WeryAI analiza el ángulo de tu producto y genera fondos con sombras e iluminación correctas, haciendo que parezca una sesión profesional de estudio."
                    },
                    {
                        "question": "¿La iluminación se verá natural?",
                        "answer": "Nuestra IA generativa (similar a Adobe Firefly o SDXL) intenta igualar la iluminación del fondo generado con tu sujeto para que se integren de forma natural."
                    },
                    {
                        "question": "¿Puedo usar AI Image Background Changer gratis?",
                        "answer": "Sí. Los nuevos usuarios reciben créditos gratis al registrarse sin necesidad de tarjeta de crédito. Además, puedes seguir consiguiendo créditos gratis con el check-in diario, completando tareas e invitando amigos, por lo que puedes seguir usando la herramienta sin pagar por adelantado."
                    }
                ]
            },
            "faq": [
                {
                    "question": "¿Cómo cambio el fondo usando texto?",
                    "answer": "Sube tu imagen y, en el cuadro de \"Prompt de Fondo\", describe la escena que quieres (p. ej., \"una cafetería acogedora\"). Haz clic en Crear y la IA generará ese fondo para ti."
                },
                {
                    "question": "¿Puedo cambiar el fondo a blanco liso?",
                    "answer": "Sí. Solo escribe \"fondo blanco puro\" o \"blanco de estudio\" en el prompt. Es perfecto para listados de productos de Amazon/eBay y fotos de identificación."
                },
                {
                    "question": "¿Es bueno para fotografía de producto?",
                    "answer": "Totalmente. WeryAI analiza el ángulo de tu producto y genera fondos con sombras e iluminación correctas, haciendo que parezca una sesión profesional de estudio."
                },
                {
                    "question": "¿La iluminación se verá natural?",
                    "answer": "Nuestra IA generativa (similar a Adobe Firefly o SDXL) intenta igualar la iluminación del fondo generado con tu sujeto para que se integren de forma natural."
                },
                {
                    "question": "¿Puedo usar AI Image Background Changer gratis?",
                    "answer": "Sí. Los nuevos usuarios reciben créditos gratis al registrarse sin necesidad de tarjeta de crédito. Además, puedes seguir consiguiendo créditos gratis con el check-in diario, completando tareas e invitando amigos, por lo que puedes seguir usando la herramienta sin pagar por adelantado."
                }
            ],
            "feature_title1": "Fotos de ID Profesionales",
            "feature_desc1": "Headshots DIY para LinkedIn: Convierte una selfie casual en una foto de perfil profesional. Cambia un fondo desordenado de dormitorio por una oficina limpia o un fondo gris de estudio al instante.",
            "feature_title2": "Fotografía de Producto Instantánea",
            "feature_desc2": "Aumenta ventas en e-commerce: Ahorra miles en sesiones. Coloca tu producto sobre una mesa de madera, una playa de arena o un podio con simples prompts. La IA añade sombras y reflejos realistas.",
            "feature_title3": "Teletransportación Creativa",
            "feature_desc3": "Viaja a cualquier lugar: ¿Quieres estar en París o en un futuro cyberpunk? Solo escríbelo. Nuestra IA reemplaza el fondo manteniendo la coherencia de la iluminación de tu foto original.",
            "howto": {
                "name": "Cómo cambiar el fondo de una foto con IA",
                "step1": {
                    "name": "Subir imagen",
                    "text": "Sube tu foto (producto o retrato) a WeryAI."
                },
                "step2": {
                    "name": "Describir fondo",
                    "text": "Ingresa una descripción de la nueva escena en el cuadro 'Prompt de fondo' (por ejemplo, 'mesa de mármol')."
                },
                "step3": {
                    "name": "Generar",
                    "text": "Haz clic en 'Crear'. La IA eliminará el fondo antiguo y generará el nuevo sin problemas."
                }
            }
        }
    },
    "fr": {
        "aiBackgroundChanger": {
            "title": "Changer le Fond d'Image par IA Gratuit | WeryAI",
            "description": "Changez instantanément l'arrière-plan de vos photos avec l'IA. Décrivez la scène souhaitée et WeryAI générera des fonds réalistes pour la photo produit, les portraits LinkedIn et les portraits créatifs. Gratuit et en ligne.",
            "keywords": "changer fond photo, générateur de fond IA, photo produit IA, fond blanc, remplacer fond en ligne, remplissage génératif fond",
            "og_title": "Changer le Fond d'Image par IA Gratuit | WeryAI",
            "og_description": "Changez instantanément l'arrière-plan de vos photos avec l'IA. Décrivez la scène souhaitée et WeryAI générera des fonds réalistes pour la photo produit, les portraits LinkedIn et les portraits créatifs. Gratuit et en ligne.",
            "twitter_title": "Changer le Fond d'Image par IA Gratuit | WeryAI",
            "twitter_description": "Changez instantanément l'arrière-plan de vos photos avec l'IA. Décrivez la scène souhaitée et WeryAI générera des fonds réalistes pour la photo produit, les portraits LinkedIn et les portraits créatifs. Gratuit et en ligne.",
            "page": {
                "title1": "Changeur de Fond IA Gratuit & Générateur",
                "title2": "Ne vous contentez pas de supprimer l'arrière-plan — remplacez-le par quelque chose de mieux. Téléchargez votre photo et décrivez n'importe quelle scène (ex. \"studio en marbre luxueux\", \"skyline de bureaux\"). Notre IA générative comprend la lumière et la perspective pour intégrer votre sujet parfaitement dans le nouvel environnement.",
                "faq": [
                    {
                        "question": "Comment changer l'arrière-plan avec du texte ?",
                        "answer": "Téléchargez votre image et, dans le champ \"Prompt d'arrière-plan\", décrivez la scène souhaitée (ex. \"un café chaleureux\"). Cliquez sur Créer et l'IA générera cet arrière-plan pour vous."
                    },
                    {
                        "question": "Puis-je mettre un fond blanc uni ?",
                        "answer": "Oui. Tapez simplement \"fond blanc pur\" ou \"blanc studio\" dans le prompt. C'est idéal pour les fiches produits Amazon/eBay et les photos d'identité."
                    },
                    {
                        "question": "Est-ce adapté à la photo produit ?",
                        "answer": "Absolument. WeryAI analyse l'angle de votre produit et génère des fonds avec des ombres et une lumière cohérentes, comme un shooting studio."
                    },
                    {
                        "question": "L'éclairage paraîtra-t-il naturel ?",
                        "answer": "Notre IA générative (similaire à Adobe Firefly ou SDXL) essaie d'aligner l'éclairage du fond généré avec celui de votre sujet pour un rendu harmonieux."
                    },
                    {
                        "question": "Puis-je utiliser AI Image Background Changer gratuitement ?",
                        "answer": "Oui. Les nouveaux utilisateurs reçoivent des crédits gratuits à l'inscription, sans carte bancaire. Vous pouvez aussi continuer à obtenir des crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d'amis, ce qui vous permet d'utiliser l'outil sans paiement anticipé."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Comment changer l'arrière-plan avec du texte ?",
                    "answer": "Téléchargez votre image et, dans le champ \"Prompt d'arrière-plan\", décrivez la scène souhaitée (ex. \"un café chaleureux\"). Cliquez sur Créer et l'IA générera cet arrière-plan pour vous."
                },
                {
                    "question": "Puis-je mettre un fond blanc uni ?",
                    "answer": "Oui. Tapez simplement \"fond blanc pur\" ou \"blanc studio\" dans le prompt. C'est idéal pour les fiches produits Amazon/eBay et les photos d'identité."
                },
                {
                    "question": "Est-ce adapté à la photo produit ?",
                    "answer": "Absolument. WeryAI analyse l'angle de votre produit et génère des fonds avec des ombres et une lumière cohérentes, comme un shooting studio."
                },
                {
                    "question": "L'éclairage paraîtra-t-il naturel ?",
                    "answer": "Notre IA générative (similaire à Adobe Firefly ou SDXL) essaie d'aligner l'éclairage du fond généré avec celui de votre sujet pour un rendu harmonieux."
                },
                {
                    "question": "Puis-je utiliser AI Image Background Changer gratuitement ?",
                    "answer": "Oui. Les nouveaux utilisateurs reçoivent des crédits gratuits à l'inscription, sans carte bancaire. Vous pouvez aussi continuer à obtenir des crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d'amis, ce qui vous permet d'utiliser l'outil sans paiement anticipé."
                }
            ],
            "feature_title1": "Photos d'Identité Professionnelles",
            "feature_desc1": "Headshots LinkedIn DIY : Transformez une selfie en photo de profil professionnelle. Remplacez instantanément un arrière-plan de chambre encombrée par un bureau propre ou un fond gris studio.",
            "feature_title2": "Photo Produit Instantanée",
            "feature_desc2": "Boostez vos ventes e-commerce : Économisez des milliers en séances photo. Placez votre produit sur une table en bois, une plage de sable ou un podium avec de simples prompts. L'IA ajoute des ombres et reflets réalistes.",
            "feature_title3": "Téléportation Créative",
            "feature_desc3": "Voyagez partout : Vous voulez être à Paris ou dans un futur cyberpunk ? Tapez-le. Notre IA remplace l'arrière-plan tout en gardant une lumière cohérente avec votre photo d'origine.",
            "howto": {
                "name": "Comment changer l'arrière-plan d'une photo avec l'IA",
                "step1": {
                    "name": "Télécharger l'image",
                    "text": "Téléchargez votre photo (produit ou portrait) sur WeryAI."
                },
                "step2": {
                    "name": "Décrire l'arrière-plan",
                    "text": "Saisissez une description de la nouvelle scène dans la case « Prompt d'arrière-plan » (par ex. « table en marbre »)."
                },
                "step3": {
                    "name": "Générer",
                    "text": "Cliquez sur « Créer ». L'IA supprimera l'ancien arrière-plan et générera le nouveau de manière transparente."
                }
            }
        }
    },
    "de": {
        "aiBackgroundChanger": {
            "title": "KI-Bildhintergrund ändern - Kostenlos | WeryAI",
            "description": "Ändern Sie Foto-Hintergründe sofort mit KI. Beschreiben Sie die gewünschte Szene, und WeryAI erzeugt realistische Hintergründe für Produktfotos, LinkedIn-Headshots und kreative Porträts. Kostenlos & online.",
            "keywords": "foto hintergrund ändern, KI hintergrund generator, produktfotografie KI, weißer hintergrund, hintergrund online ersetzen, generatives füllen hintergrund",
            "og_title": "KI-Bildhintergrund ändern - Kostenlos | WeryAI",
            "og_description": "Ändern Sie Foto-Hintergründe sofort mit KI. Beschreiben Sie die gewünschte Szene, und WeryAI erzeugt realistische Hintergründe für Produktfotos, LinkedIn-Headshots und kreative Porträts. Kostenlos & online.",
            "twitter_title": "KI-Bildhintergrund ändern - Kostenlos | WeryAI",
            "twitter_description": "Ändern Sie Foto-Hintergründe sofort mit KI. Beschreiben Sie die gewünschte Szene, und WeryAI erzeugt realistische Hintergründe für Produktfotos, LinkedIn-Headshots und kreative Porträts. Kostenlos & online.",
            "page": {
                "title1": "Kostenloser KI-Hintergrundwechsler & Generator",
                "title2": "Entfernen Sie den Hintergrund nicht nur – ersetzen Sie ihn durch etwas Besseres. Laden Sie Ihr Foto hoch und beschreiben Sie eine Szene (z. B. „luxuriöses Marmor-Studio“, „Office-Skyline“). Unsere Generative KI versteht Licht und Perspektive und blendet Ihr Motiv perfekt in die neue Umgebung ein.",
                "faq": [
                    {
                        "question": "Wie ändere ich den Hintergrund mit Text?",
                        "answer": "Laden Sie Ihr Bild hoch und beschreiben Sie im Feld „Background Prompt“ die gewünschte Szene (z. B. „ein gemütliches Café“). Klicken Sie auf Erstellen – die KI generiert den Hintergrund für Sie."
                    },
                    {
                        "question": "Kann ich den Hintergrund auf reines Weiß ändern?",
                        "answer": "Ja. Tippen Sie einfach „pure white background“ oder „studio white“ in das Prompt-Feld. Perfekt für Amazon/eBay-Produktbilder und Ausweisfotos."
                    },
                    {
                        "question": "Ist das gut für Produktfotografie?",
                        "answer": "Absolut. WeryAI analysiert den Winkel Ihres Produkts und erzeugt Hintergründe mit passenden Schatten und Beleuchtung – wie bei einem professionellen Studio-Shooting."
                    },
                    {
                        "question": "Wirkt die Beleuchtung natürlich?",
                        "answer": "Unsere Generative KI (ähnlich Adobe Firefly oder SDXL) versucht, die Beleuchtung des generierten Hintergrunds an Ihr Motiv anzupassen, damit alles nahtlos wirkt."
                    },
                    {
                        "question": "Kann ich AI Image Background Changer kostenlos nutzen?",
                        "answer": "Ja. Neue Nutzer erhalten bei der Registrierung kostenlose Credits, ganz ohne Kreditkarte. Außerdem können Sie durch tägliches Einchecken, das Abschließen von Aufgaben und das Einladen von Freunden weiterhin kostenlose Credits erhalten, sodass Sie das Tool ohne Vorauszahlung weiter nutzen können."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Wie ändere ich den Hintergrund mit Text?",
                    "answer": "Laden Sie Ihr Bild hoch und beschreiben Sie im Feld „Background Prompt“ die gewünschte Szene (z. B. „ein gemütliches Café“). Klicken Sie auf Erstellen – die KI generiert den Hintergrund für Sie."
                },
                {
                    "question": "Kann ich den Hintergrund auf reines Weiß ändern?",
                    "answer": "Ja. Tippen Sie einfach „pure white background“ oder „studio white“ in das Prompt-Feld. Perfekt für Amazon/eBay-Produktbilder und Ausweisfotos."
                },
                {
                    "question": "Ist das gut für Produktfotografie?",
                    "answer": "Absolut. WeryAI analysiert den Winkel Ihres Produkts und erzeugt Hintergründe mit passenden Schatten und Beleuchtung – wie bei einem professionellen Studio-Shooting."
                },
                {
                    "question": "Wirkt die Beleuchtung natürlich?",
                    "answer": "Unsere Generative KI (ähnlich Adobe Firefly oder SDXL) versucht, die Beleuchtung des generierten Hintergrunds an Ihr Motiv anzupassen, damit alles nahtlos wirkt."
                },
                {
                    "question": "Kann ich AI Image Background Changer kostenlos nutzen?",
                    "answer": "Ja. Neue Nutzer erhalten bei der Registrierung kostenlose Credits, ganz ohne Kreditkarte. Außerdem können Sie durch tägliches Einchecken, das Abschließen von Aufgaben und das Einladen von Freunden weiterhin kostenlose Credits erhalten, sodass Sie das Tool ohne Vorauszahlung weiter nutzen können."
                }
            ],
            "feature_title1": "Professionelle Ausweisfotos",
            "feature_desc1": "DIY LinkedIn-Headshots: Machen Sie aus einer einfachen Selfie ein professionelles Profilbild. Tauschen Sie einen unordentlichen Schlafzimmerhintergrund sofort gegen ein sauberes Büro oder Studio-Grau.",
            "feature_title2": "Sofortige Produktfotografie",
            "feature_desc2": "Mehr E-Commerce-Umsatz: Sparen Sie tausende Euro an Fotoshootings. Platzieren Sie Ihr Produkt per Textprompt auf einem Holztisch, am Strand oder auf einem Podest. Die KI fügt realistische Schatten und Reflexionen hinzu.",
            "feature_title3": "Kreative Teleportation",
            "feature_desc3": "Reisen Sie überallhin: Paris oder eine Cyberpunk-Zukunft? Einfach eintippen. Unsere KI ersetzt den Hintergrund und hält die Beleuchtung Ihrer Originalaufnahme konsistent.",
            "howto": {
                "name": "Wie man den Fotohintergrund mit KI ändert",
                "step1": {
                    "name": "Bild hochladen",
                    "text": "Laden Sie Ihr Foto (Produkt oder Porträt) bei WeryAI hoch."
                },
                "step2": {
                    "name": "Hintergrund beschreiben",
                    "text": "Geben Sie eine Beschreibung der neuen Szene in das Feld 'Hintergrund-Prompt' ein (z. B. 'Marmortisch')."
                },
                "step3": {
                    "name": "Generieren",
                    "text": "Klicken Sie auf 'Erstellen'. Die KI entfernt den alten Hintergrund und generiert nahtlos den neuen."
                }
            }
        }
    },
    "ru": {
        "aiBackgroundChanger": {
            "title": "ИИ Смена Фона Изображения - Бесплатно | WeryAI",
            "description": "Мгновенно меняйте фон на фото с помощью ИИ. Опишите нужную сцену, и WeryAI создаст реалистичные фоны для предметной съемки, деловых фото для LinkedIn и креативных портретов. Бесплатно и онлайн.",
            "keywords": "сменить фон фото, генератор фона ИИ, предметная съемка ИИ, сделать белый фон, заменить фон онлайн, генеративная заливка фона",
            "og_title": "ИИ Смена Фона Изображения - Бесплатно | WeryAI",
            "og_description": "Мгновенно меняйте фон на фото с помощью ИИ. Опишите нужную сцену, и WeryAI создаст реалистичные фоны для предметной съемки, деловых фото для LinkedIn и креативных портретов. Бесплатно и онлайн.",
            "twitter_title": "ИИ Смена Фона Изображения - Бесплатно | WeryAI",
            "twitter_description": "Мгновенно меняйте фон на фото с помощью ИИ. Опишите нужную сцену, и WeryAI создаст реалистичные фоны для предметной съемки, деловых фото для LinkedIn и креативных портретов. Бесплатно и онлайн.",
            "page": {
                "title1": "Бесплатный ИИ-Сменщик Фона и Генератор",
                "title2": "Не просто удаляйте фон — заменяйте его на более подходящий. Загрузите фото и опишите любую сцену (например, «роскошная мраморная студия», «офисный скайлайн»). Наша генеративная ИИ понимает свет и перспективу, чтобы идеально вписать ваш объект в новую среду.",
                "faq": [
                    {
                        "question": "Как изменить фон с помощью текста?",
                        "answer": "Загрузите изображение и в поле «Промпт фона» опишите нужную сцену (например, «уютная кофейня»). Нажмите «Создать», и ИИ сгенерирует фон."
                    },
                    {
                        "question": "Можно ли сделать фон чисто белым?",
                        "answer": "Да. Просто введите в промпт «pure white background» или «studio white». Это идеально для карточек товаров на Amazon/eBay и фото на документы."
                    },
                    {
                        "question": "Подходит ли это для предметной съемки?",
                        "answer": "Конечно. WeryAI анализирует угол вашего товара и генерирует фон с правильными тенями и освещением, как в профессиональной студии."
                    },
                    {
                        "question": "Будет ли освещение выглядеть естественно?",
                        "answer": "Наша генеративная ИИ (похожа на Adobe Firefly или SDXL) старается согласовать освещение фона с объектом, чтобы результат выглядел цельно."
                    },
                    {
                        "question": "Можно ли пользоваться AI Image Background Changer бесплатно?",
                        "answer": "Да. Новые пользователи получают бесплатные кредиты при регистрации без необходимости вводить банковскую карту. Вы также можете и дальше получать бесплатные кредиты за ежедневные отметки, выполнение заданий и приглашение друзей, поэтому инструментом можно пользоваться без предоплаты."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Как изменить фон с помощью текста?",
                    "answer": "Загрузите изображение и в поле «Промпт фона» опишите нужную сцену (например, «уютная кофейня»). Нажмите «Создать», и ИИ сгенерирует фон."
                },
                {
                    "question": "Можно ли сделать фон чисто белым?",
                    "answer": "Да. Просто введите в промпт «pure white background» или «studio white». Это идеально для карточек товаров на Amazon/eBay и фото на документы."
                },
                {
                    "question": "Подходит ли это для предметной съемки?",
                    "answer": "Конечно. WeryAI анализирует угол вашего товара и генерирует фон с правильными тенями и освещением, как в профессиональной студии."
                },
                {
                    "question": "Будет ли освещение выглядеть естественно?",
                    "answer": "Наша генеративная ИИ (похожа на Adobe Firefly или SDXL) старается согласовать освещение фона с объектом, чтобы результат выглядел цельно."
                },
                {
                    "question": "Можно ли пользоваться AI Image Background Changer бесплатно?",
                    "answer": "Да. Новые пользователи получают бесплатные кредиты при регистрации без необходимости вводить банковскую карту. Вы также можете и дальше получать бесплатные кредиты за ежедневные отметки, выполнение заданий и приглашение друзей, поэтому инструментом можно пользоваться без предоплаты."
                }
            ],
            "feature_title1": "Профессиональные Фото для Документов",
            "feature_desc1": "DIY LinkedIn-Headshots: Превратите обычное селфи в профессиональное фото профиля. Мгновенно замените фон спальни на чистый офис или студийный серый.",
            "feature_title2": "Мгновенная Предметная Съемка",
            "feature_desc2": "Рост продаж в e-commerce: Сэкономьте тысячи на фотосессиях. Разместите товар на деревянном столе, на пляже или на подиуме с помощью простых промптов — ИИ добавит реалистичные тени и отражения.",
            "feature_title3": "Креативная Телепортация",
            "feature_desc3": "Путешествуйте куда угодно: Хотите оказаться в Париже или в киберпанк-будущем? Просто напишите это. Наша ИИ заменит фон, сохранив согласованное освещение с оригинальным фото.",
            "howto": {
                "name": "Как изменить фон фото с помощью ИИ",
                "step1": {
                    "name": "Загрузить изображение",
                    "text": "Загрузите свое фото (продукт или портрет) в WeryAI."
                },
                "step2": {
                    "name": "Описать фон",
                    "text": "Введите описание новой сцены в поле «Подсказка для фона» (например, «мраморный стол»)."
                },
                "step3": {
                    "name": "Сгенерировать",
                    "text": "Нажмите «Создать». ИИ удалит старый фон и плавно сгенерирует новый."
                }
            }
        }
    },
    "pt": {
        "aiBackgroundChanger": {
            "title": "Trocar Fundo de Imagem com IA Grátis | WeryAI",
            "description": "Altere o fundo de fotos instantaneamente com IA. Descreva a cena que você quer e a WeryAI gerará fundos realistas para fotografia de produtos, headshots para LinkedIn e retratos criativos. Grátis e online.",
            "keywords": "mudar fundo de foto, gerador de fundo IA, fotografia de produto IA, fazer fundo branco, substituir fundo online, preenchimento generativo de fundo",
            "og_title": "Trocar Fundo de Imagem com IA Grátis | WeryAI",
            "og_description": "Altere o fundo de fotos instantaneamente com IA. Descreva a cena que você quer e a WeryAI gerará fundos realistas para fotografia de produtos, headshots para LinkedIn e retratos criativos. Grátis e online.",
            "twitter_title": "Trocar Fundo de Imagem com IA Grátis | WeryAI",
            "twitter_description": "Altere o fundo de fotos instantaneamente com IA. Descreva a cena que você quer e a WeryAI gerará fundos realistas para fotografia de produtos, headshots para LinkedIn e retratos criativos. Grátis e online.",
            "page": {
                "title1": "Alterador de Fundo IA Grátis e Gerador",
                "title2": "Não apenas remova o fundo — substitua por algo melhor. Envie sua foto e descreva qualquer cena (ex.: \"estúdio de mármore luxuoso\", \"skyline de escritório\"). Nossa IA generativa entende iluminação e perspectiva para misturar seu assunto perfeitamente no novo ambiente.",
                "faq": [
                    {
                        "question": "Como mudar o fundo usando texto?",
                        "answer": "Envie sua imagem e, na caixa \"Prompt de Fundo\", descreva a cena que você quer (ex.: \"um café aconchegante\"). Clique em Criar e a IA gerará esse fundo para você."
                    },
                    {
                        "question": "Posso mudar o fundo para branco puro?",
                        "answer": "Sim. Basta digitar \"pure white background\" ou \"studio white\" no prompt. Isso é perfeito para anúncios de produtos na Amazon/eBay e fotos de documento."
                    },
                    {
                        "question": "Isso é bom para fotografia de produtos?",
                        "answer": "Com certeza. A WeryAI analisa o ângulo do seu produto e gera fundos com sombras e iluminação corretas, fazendo parecer um ensaio profissional em estúdio."
                    },
                    {
                        "question": "A iluminação vai parecer natural?",
                        "answer": "Nossa IA generativa (semelhante ao Adobe Firefly ou SDXL) tenta combinar a iluminação do fundo gerado com o seu assunto para uma composição natural."
                    },
                    {
                        "question": "Posso usar o AI Image Background Changer grátis?",
                        "answer": "Sim. Novos usuários recebem créditos grátis ao se cadastrar, sem precisar de cartão de crédito. Você também pode continuar ganhando créditos grátis com check-in diário, conclusão de tarefas e convite de amigos, então é possível continuar usando a ferramenta sem pagar antecipadamente."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Como mudar o fundo usando texto?",
                    "answer": "Envie sua imagem e, na caixa \"Prompt de Fundo\", descreva a cena que você quer (ex.: \"um café aconchegante\"). Clique em Criar e a IA gerará esse fundo para você."
                },
                {
                    "question": "Posso mudar o fundo para branco puro?",
                    "answer": "Sim. Basta digitar \"pure white background\" ou \"studio white\" no prompt. Isso é perfeito para anúncios de produtos na Amazon/eBay e fotos de documento."
                },
                {
                    "question": "Isso é bom para fotografia de produtos?",
                    "answer": "Com certeza. A WeryAI analisa o ângulo do seu produto e gera fundos com sombras e iluminação corretas, fazendo parecer um ensaio profissional em estúdio."
                },
                {
                    "question": "A iluminação vai parecer natural?",
                    "answer": "Nossa IA generativa (semelhante ao Adobe Firefly ou SDXL) tenta combinar a iluminação do fundo gerado com o seu assunto para uma composição natural."
                },
                {
                    "question": "Posso usar o AI Image Background Changer grátis?",
                    "answer": "Sim. Novos usuários recebem créditos grátis ao se cadastrar, sem precisar de cartão de crédito. Você também pode continuar ganhando créditos grátis com check-in diário, conclusão de tarefas e convite de amigos, então é possível continuar usando a ferramenta sem pagar antecipadamente."
                }
            ],
            "feature_title1": "Fotos Profissionais de Identidade",
            "feature_desc1": "Headshots DIY para LinkedIn: Transforme uma selfie casual em uma foto de perfil profissional. Troque um fundo bagunçado de quarto por um escritório limpo ou um fundo cinza de estúdio instantaneamente.",
            "feature_title2": "Fotografia de Produto Instantânea",
            "feature_desc2": "Aumente vendas no e-commerce: Economize milhares em ensaios fotográficos. Coloque seu produto em uma mesa de madeira, uma praia de areia ou um pedestal com prompts simples. A IA adiciona sombras e reflexos realistas.",
            "feature_title3": "Teletransporte Criativo",
            "feature_desc3": "Viaje para qualquer lugar: Quer estar em Paris ou em um futuro cyberpunk? Basta digitar. Nossa IA substitui o fundo mantendo a iluminação consistente com sua foto original.",
            "howto": {
                "name": "Como mudar o fundo da foto com IA",
                "step1": {
                    "name": "Enviar imagem",
                    "text": "Envie sua foto (produto ou retrato) para o WeryAI."
                },
                "step2": {
                    "name": "Descrever fundo",
                    "text": "Insira uma descrição da nova cena na caixa 'Prompt de fundo' (por exemplo, 'mesa de mármore')."
                },
                "step3": {
                    "name": "Gerar",
                    "text": "Clique em 'Criar'. A IA removerá o fundo antigo e gerará o novo perfeitamente."
                }
            }
        }
    },
    "it": {
        "aiBackgroundChanger": {
            "title": "Cambiare Sfondo Immagine con IA Gratis | WeryAI",
            "description": "Cambia lo sfondo delle foto all'istante con l'IA. Descrivi la scena che vuoi e WeryAI genererà sfondi realistici per foto prodotto, headshot per LinkedIn e ritratti creativi. Gratis e online.",
            "keywords": "cambiare sfondo foto, generatore sfondi IA, fotografia prodotto IA, sfondo bianco, sostituire sfondo online, riempimento generativo sfondo",
            "og_title": "Cambiare Sfondo Immagine con IA Gratis | WeryAI",
            "og_description": "Cambia lo sfondo delle foto all'istante con l'IA. Descrivi la scena che vuoi e WeryAI genererà sfondi realistici per foto prodotto, headshot per LinkedIn e ritratti creativi. Gratis e online.",
            "twitter_title": "Cambiare Sfondo Immagine con IA Gratis | WeryAI",
            "twitter_description": "Cambia lo sfondo delle foto all'istante con l'IA. Descrivi la scena che vuoi e WeryAI genererà sfondi realistici per foto prodotto, headshot per LinkedIn e ritratti creativi. Gratis e online.",
            "page": {
                "title1": "Cambia Sfondo IA Gratis & Generatore",
                "title2": "Non limitarti a rimuovere lo sfondo: sostituiscilo con qualcosa di meglio. Carica la tua foto e descrivi qualsiasi scena (es.: \"studio in marmo di lusso\", \"skyline di uffici\"). La nostra IA generativa capisce luce e prospettiva per fondere il soggetto perfettamente nel nuovo ambiente.",
                "faq": [
                    {
                        "question": "Come cambio lo sfondo usando il testo?",
                        "answer": "Carica la tua immagine e, nella casella \"Prompt Sfondo\", descrivi la scena che vuoi (es.: \"un bar accogliente\"). Clicca su Crea e l'IA genererà quello sfondo per te."
                    },
                    {
                        "question": "Posso cambiare lo sfondo in bianco puro?",
                        "answer": "Sì. Basta digitare \"pure white background\" o \"studio white\" nel prompt. È perfetto per le schede prodotto Amazon/eBay e per le foto documento."
                    },
                    {
                        "question": "È adatto alla fotografia di prodotto?",
                        "answer": "Assolutamente. WeryAI analizza l'angolazione del prodotto e genera sfondi con ombre e illuminazione corrette, facendolo sembrare uno shooting professionale."
                    },
                    {
                        "question": "L'illuminazione sembrerà naturale?",
                        "answer": "La nostra IA generativa (simile ad Adobe Firefly o SDXL) prova ad abbinare l'illuminazione dello sfondo generato al soggetto, fondendoli in modo naturale."
                    },
                    {
                        "question": "Posso usare AI Image Background Changer gratis?",
                        "answer": "Sì. I nuovi utenti ricevono crediti gratuiti al momento della registrazione senza carta di credito. Inoltre, puoi continuare a ottenere crediti gratuiti con il check-in giornaliero, il completamento delle attività e l'invito di amici, così puoi continuare a usare lo strumento senza pagare in anticipo."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Come cambio lo sfondo usando il testo?",
                    "answer": "Carica la tua immagine e, nella casella \"Prompt Sfondo\", descrivi la scena che vuoi (es.: \"un bar accogliente\"). Clicca su Crea e l'IA genererà quello sfondo per te."
                },
                {
                    "question": "Posso cambiare lo sfondo in bianco puro?",
                    "answer": "Sì. Basta digitare \"pure white background\" o \"studio white\" nel prompt. È perfetto per le schede prodotto Amazon/eBay e per le foto documento."
                },
                {
                    "question": "È adatto alla fotografia di prodotto?",
                    "answer": "Assolutamente. WeryAI analizza l'angolazione del prodotto e genera sfondi con ombre e illuminazione corrette, facendolo sembrare uno shooting professionale."
                },
                {
                    "question": "L'illuminazione sembrerà naturale?",
                    "answer": "La nostra IA generativa (simile ad Adobe Firefly o SDXL) prova ad abbinare l'illuminazione dello sfondo generato al soggetto, fondendoli in modo naturale."
                },
                {
                    "question": "Posso usare AI Image Background Changer gratis?",
                    "answer": "Sì. I nuovi utenti ricevono crediti gratuiti al momento della registrazione senza carta di credito. Inoltre, puoi continuare a ottenere crediti gratuiti con il check-in giornaliero, il completamento delle attività e l'invito di amici, così puoi continuare a usare lo strumento senza pagare in anticipo."
                }
            ],
            "feature_title1": "Foto Professionali per ID",
            "feature_desc1": "Headshot LinkedIn fai-da-te: Trasforma una selfie casual in una foto profilo professionale. Cambia al volo uno sfondo disordinato della camera in un ufficio pulito o in un grigio da studio.",
            "feature_title2": "Fotografia di Prodotto Istantanea",
            "feature_desc2": "Aumenta le vendite e-commerce: Risparmia migliaia in shooting. Metti il prodotto su un tavolo in legno, una spiaggia sabbiosa o un piedistallo con semplici prompt. L'IA aggiunge ombre e riflessi realistici.",
            "feature_title3": "Teletrasporto Creativo",
            "feature_desc3": "Viaggia ovunque: Vuoi essere a Parigi o in un futuro cyberpunk? Scrivilo e basta. La nostra IA sostituisce lo sfondo mantenendo la coerenza della luce della foto originale.",
            "howto": {
                "name": "Come cambiare lo sfondo della foto con l'IA",
                "step1": {
                    "name": "Carica immagine",
                    "text": "Carica la tua foto (prodotto o ritratto) su WeryAI."
                },
                "step2": {
                    "name": "Descrivi sfondo",
                    "text": "Inserisci una descrizione della nuova scena nella casella 'Prompt di sfondo' (es. 'tavolo di marmo')."
                },
                "step3": {
                    "name": "Genera",
                    "text": "Fai clic su 'Crea'. L'IA rimuoverà il vecchio sfondo e genererà senza interruzioni il nuovo."
                }
            }
        }
    },
    "ar": {
        "aiBackgroundChanger": {
            "title": "تغيير خلفية الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "description": "غيّر خلفية الصور فورًا باستخدام الذكاء الاصطناعي. صف المشهد الذي تريده وسيقوم WeryAI بإنشاء خلفيات واقعية لتصوير المنتجات وصور LinkedIn الاحترافية واللقطات الإبداعية. مجاني وعبر الإنترنت.",
            "keywords": "تغيير خلفية الصورة, مولد خلفيات بالذكاء الاصطناعي, تصوير منتجات بالذكاء الاصطناعي, صنع خلفية بيضاء, استبدال الخلفية عبر الإنترنت, تعبئة توليدية للخلفية",
            "og_title": "تغيير خلفية الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "og_description": "غيّر خلفية الصور فورًا باستخدام الذكاء الاصطناعي. صف المشهد الذي تريده وسيقوم WeryAI بإنشاء خلفيات واقعية لتصوير المنتجات وصور LinkedIn الاحترافية واللقطات الإبداعية. مجاني وعبر الإنترنت.",
            "twitter_title": "تغيير خلفية الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "twitter_description": "غيّر خلفية الصور فورًا باستخدام الذكاء الاصطناعي. صف المشهد الذي تريده وسيقوم WeryAI بإنشاء خلفيات واقعية لتصوير المنتجات وصور LinkedIn الاحترافية واللقطات الإبداعية. مجاني وعبر الإنترنت.",
            "page": {
                "title1": "مغيّر الخلفية ومولّدها بالذكاء الاصطناعي مجانًا",
                "title2": "لا تكتفِ بإزالة الخلفية—استبدلها بما هو أفضل. ارفع صورتك وصف أي مشهد (مثل \"استوديو رخام فاخر\" أو \"أفق مكاتب\"). يفهم ذكاؤنا الاصطناعي التوليدي الإضاءة والمنظور لدمج موضوعك بشكل مثالي في البيئة الجديدة.",
                "faq": [
                    {
                        "question": "كيف أغيّر الخلفية باستخدام النص؟",
                        "answer": "ارفع صورتك، وفي مربع \"موجه الخلفية\" صف المشهد الذي تريده (مثل \"مقهى دافئ\"). انقر على \"إنشاء\" وسيقوم الذكاء الاصطناعي بإنشاء الخلفية لك."
                    },
                    {
                        "question": "هل يمكنني تغيير الخلفية إلى أبيض صافٍ؟",
                        "answer": "نعم. اكتب فقط \"pure white background\" أو \"studio white\" في الموجه. هذا مثالي لصور منتجات Amazon/eBay وصور الهوية الرسمية."
                    },
                    {
                        "question": "هل هذا مناسب لتصوير المنتجات؟",
                        "answer": "بالتأكيد. يحلل WeryAI زاوية منتجك ويولّد خلفيات بظلال وإضاءة صحيحة لتبدو كجلسة تصوير احترافية في الاستوديو."
                    },
                    {
                        "question": "هل ستبدو الإضاءة طبيعية؟",
                        "answer": "يحاول ذكاؤنا الاصطناعي التوليدي (المشابه لـ Adobe Firefly أو SDXL) مطابقة إضاءة الخلفية المولّدة مع موضوعك لدمجهما بسلاسة."
                    },
                    {
                        "question": "هل يمكنني استخدام AI Image Background Changer مجانًا؟",
                        "answer": "نعم. يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل بدون الحاجة إلى بطاقة ائتمان. ويمكنك أيضًا الاستمرار في الحصول على أرصدة مجانية من خلال تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء، لذلك يمكنك متابعة استخدام الأداة دون دفع مسبق."
                    }
                ]
            },
            "faq": [
                {
                    "question": "كيف أغيّر الخلفية باستخدام النص؟",
                    "answer": "ارفع صورتك، وفي مربع \"موجه الخلفية\" صف المشهد الذي تريده (مثل \"مقهى دافئ\"). انقر على \"إنشاء\" وسيقوم الذكاء الاصطناعي بإنشاء الخلفية لك."
                },
                {
                    "question": "هل يمكنني تغيير الخلفية إلى أبيض صافٍ؟",
                    "answer": "نعم. اكتب فقط \"pure white background\" أو \"studio white\" في الموجه. هذا مثالي لصور منتجات Amazon/eBay وصور الهوية الرسمية."
                },
                {
                    "question": "هل هذا مناسب لتصوير المنتجات؟",
                    "answer": "بالتأكيد. يحلل WeryAI زاوية منتجك ويولّد خلفيات بظلال وإضاءة صحيحة لتبدو كجلسة تصوير احترافية في الاستوديو."
                },
                {
                    "question": "هل ستبدو الإضاءة طبيعية؟",
                    "answer": "يحاول ذكاؤنا الاصطناعي التوليدي (المشابه لـ Adobe Firefly أو SDXL) مطابقة إضاءة الخلفية المولّدة مع موضوعك لدمجهما بسلاسة."
                },
                {
                    "question": "هل يمكنني استخدام AI Image Background Changer مجانًا؟",
                    "answer": "نعم. يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل بدون الحاجة إلى بطاقة ائتمان. ويمكنك أيضًا الاستمرار في الحصول على أرصدة مجانية من خلال تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء، لذلك يمكنك متابعة استخدام الأداة دون دفع مسبق."
                }
            ],
            "feature_title1": "صور هوية احترافية",
            "feature_desc1": "صور LinkedIn احترافية بنفسك: حوّل سيلفي عادي إلى صورة ملف شخصي احترافية. غيّر خلفية غرفة فوضوية إلى مكتب نظيف أو خلفية رمادية للاستوديو فورًا.",
            "feature_title2": "تصوير منتجات فوري",
            "feature_desc2": "زد مبيعات التجارة الإلكترونية: وفّر آلافًا على جلسات التصوير. ضع منتجك على طاولة خشبية أو شاطئ رملي أو منصة باستخدام موجهات نصية بسيطة. يضيف الذكاء الاصطناعي ظلالًا وانعكاسات واقعية.",
            "feature_title3": "انتقال إبداعي",
            "feature_desc3": "سافر إلى أي مكان: تريد أن تكون في باريس أو في مستقبل سايبربانك؟ فقط اكتب ذلك. يستبدل ذكاؤنا الاصطناعي الخلفية مع الحفاظ على اتساق الإضاءة مع صورتك الأصلية.",
            "howto": {
                "name": "كيفية تغيير خلفية الصورة بالذكاء الاصطناعي",
                "step1": {
                    "name": "تحميل الصورة",
                    "text": "قم بتحميل صورتك (منتج أو صورة شخصية) إلى WeryAI."
                },
                "step2": {
                    "name": "وصف الخلفية",
                    "text": "أدخل وصفًا للمشهد الجديد في مربع 'موجه الخلفية' (مثل 'طاولة رخامية')."
                },
                "step3": {
                    "name": "إنشاء",
                    "text": "انقر على 'إنشاء'. سيقوم الذكاء الاصطناعي بإزالة الخلفية القديمة وإنشاء الخلفية الجديدة بسلاسة."
                }
            }
        }
    },
    "tw": {
        "aiBackgroundChanger": {
            "title": "免費 AI 圖片背景更換器 - 純色背景或場景換背景 | WeryAI",
            "description": "線上用 AI 更換圖片背景。可手動選擇純色背景，快速製作白底商品圖和證件照；也可輸入提示詞，把背景替換成辦公室、影棚、咖啡館、海邊等任意場景。",
            "keywords": "AI 圖片背景更換器, 更換照片背景, 圖片換背景, 純色背景, 白底商品圖, 證件照換背景, 線上替換背景, 場景背景生成",
            "howto": {
                "name": "如何使用 AI 更換照片背景",
                "step1": {
                    "name": "上傳圖片",
                    "text": "上傳一張主體清晰的產品圖、人像或寵物圖片到 WeryAI。"
                },
                "step2": {
                    "name": "選擇顏色或輸入提示詞",
                    "text": "如果你想要純色背景，直接選擇顏色；如果你想要新的場景背景，就輸入提示詞。顏色與提示詞一次選一種即可。"
                },
                "step3": {
                    "name": "產生並下載",
                    "text": "點擊「建立」，AI 會保留主體並在幾秒內替換原背景。"
                }
            },
            "og_title": "免費 AI 圖片背景更換器 - 純色背景或場景換背景 | WeryAI",
            "og_description": "線上用 AI 更換圖片背景。可手動選擇純色背景，快速製作白底商品圖和證件照；也可輸入提示詞，把背景替換成辦公室、影棚、咖啡館、海邊等任意場景。",
            "twitter_title": "免費 AI 圖片背景更換器 - 純色背景或場景換背景 | WeryAI",
            "twitter_description": "線上用 AI 更換圖片背景。可手動選擇純色背景，快速製作白底商品圖和證件照；也可輸入提示詞，把背景替換成辦公室、影棚、咖啡館、海邊等任意場景。",
            "app_name": "WeryAI AI 圖片背景更換器",
            "app_desc": "一張圖，兩種換背景方式。你可以手動選擇背景顏色，快速生成純色背景；也可以輸入提示詞，把原圖替換成辦公室、影棚、咖啡館、海邊等任意新場景。",
            "page": {
                "title1": "免費 AI 圖片背景更換器",
                "title2": "上傳一張圖片後，你可以選擇兩種背景更換方式：手動選擇背景顏色，快速生成乾淨統一的純色背景；或輸入提示詞，把原背景替換成辦公室、影棚、咖啡館、海邊等任意新場景。",
                "faq": [
                    {
                        "question": "如何用 AI 更換圖片背景？",
                        "answer": "上傳圖片後，選擇一種背景模式即可：想要純色背景就直接選顏色，想要新場景就輸入提示詞。點擊「建立」後，AI 會自動保留主體並替換原背景。"
                    },
                    {
                        "question": "可以換成純白或其他純色背景嗎？",
                        "answer": "可以。使用顏色選擇器即可快速切換成白色、黑色或自訂 HEX 純色背景，非常適合商品主圖、證件照和品牌統一素材。"
                    },
                    {
                        "question": "可以透過提示詞生成新的場景背景嗎？",
                        "answer": "可以。你可以輸入「大理石影棚」「辦公室桌面」「咖啡館角落」「海邊日落」等場景描述，AI 會圍繞主體生成新的背景環境。"
                    },
                    {
                        "question": "什麼時候該用顏色模式，什麼時候該用提示詞模式？",
                        "answer": "如果你需要白底圖、品牌色背景或標準化頭像，優先用顏色模式；如果你想做行銷海報、生活風格場景圖或創意內容，就用提示詞模式。"
                    },
                    {
                        "question": "AI 圖片背景更換器可以免費使用嗎？",
                        "answer": "可以。新用戶註冊即可獲得免費積分，無需信用卡。之後還可以透過每日簽到、完成任務和邀請好友持續獲得免費積分，因此無需預付費也能繼續使用圖片背景更換器。"
                    }
                ],
                "feature_title1": "純色背景快速出圖",
                "feature_desc1": "需要白底圖、黑底圖或品牌色背景時，直接選擇顏色即可把雜亂背景改成乾淨統一的純色底，適合商品圖、證件照與履歷頭像。",
                "feature_title2": "提示詞換背景，場景更靈活",
                "feature_desc2": "輸入你想要的場景，例如大理石影棚、辦公室桌面、咖啡館角落或海邊日落，AI 會圍繞主體生成新的背景環境。",
                "feature_title3": "主體清晰保留，結果更自然",
                "feature_desc3": "無論是人物、寵物還是商品，WeryAI 都會優先保留主體的視覺重點，讓背景替換後的成圖依然清晰、自然、可直接使用。"
            },
            "faq": [
                {
                    "question": "如何用 AI 更換圖片背景？",
                    "answer": "上傳圖片後，選擇一種背景模式即可：想要純色背景就直接選顏色，想要新場景就輸入提示詞。點擊「建立」後，AI 會自動保留主體並替換原背景。"
                },
                {
                    "question": "可以換成純白或其他純色背景嗎？",
                    "answer": "可以。使用顏色選擇器即可快速切換成白色、黑色或自訂 HEX 純色背景，非常適合商品主圖、證件照和品牌統一素材。"
                },
                {
                    "question": "可以透過提示詞生成新的場景背景嗎？",
                    "answer": "可以。你可以輸入「大理石影棚」「辦公室桌面」「咖啡館角落」「海邊日落」等場景描述，AI 會圍繞主體生成新的背景環境。"
                },
                {
                    "question": "什麼時候該用顏色模式，什麼時候該用提示詞模式？",
                    "answer": "如果你需要白底圖、品牌色背景或標準化頭像，優先用顏色模式；如果你想做行銷海報、生活風格場景圖或創意內容，就用提示詞模式。"
                },
                {
                    "question": "AI 圖片背景更換器可以免費使用嗎？",
                    "answer": "可以。新用戶註冊即可獲得免費積分，無需信用卡。之後還可以透過每日簽到、完成任務和邀請好友持續獲得免費積分，因此無需預付費也能繼續使用圖片背景更換器。"
                }
            ],
            "feature_title1": "純色背景快速出圖",
            "feature_desc1": "需要白底圖、黑底圖或品牌色背景時，直接選擇顏色即可把雜亂背景改成乾淨統一的純色底，適合商品圖、證件照與履歷頭像。",
            "feature_title2": "提示詞換背景，場景更靈活",
            "feature_desc2": "輸入你想要的場景，例如大理石影棚、辦公室桌面、咖啡館角落或海邊日落，AI 會圍繞主體生成新的背景環境。",
            "feature_title3": "主體清晰保留，結果更自然",
            "feature_desc3": "無論是人物、寵物還是商品，WeryAI 都會優先保留主體的視覺重點，讓背景替換後的成圖依然清晰、自然、可直接使用。",
            "feature_title4": "雙模式切換更省事",
            "feature_desc4": "同一個工具就能完成標準白底圖與創意場景圖，不必在多個編輯器之間切換，出圖流程更直接。"
        }
    },
    "pl": {
        "aiBackgroundChanger": {
            "title": "Darmowy AI Zmieniacz Tła Zdjęć Online | WeryAI",
            "description": "Zmień tło zdjęcia jednym kliknięciem — wybierz jednolity kolor lub opisz nową scenę. AI wygeneruje nowe tło w sekundy. Idealne do zdjęć produktowych i profilowych. Darmowe kredyty na start.",
            "keywords": "zmieniacz tła AI, zmiana tła zdjęcia, białe tło zdjęcia, zamiana tła online, usunięcie tła AI, tło do zdjęć produktowych, generator tła AI",
            "og_title": "Darmowy AI Zmieniacz Tła Zdjęć Online | WeryAI",
            "og_description": "Zmień tło zdjęcia jednym kliknięciem — wybierz jednolity kolor lub opisz nową scenę. AI wygeneruje nowe tło w sekundy. Idealne do zdjęć produktowych i profilowych. Darmowe kredyty na start.",
            "twitter_title": "Darmowy AI Zmieniacz Tła Zdjęć Online | WeryAI",
            "twitter_description": "Zmień tło zdjęcia jednym kliknięciem — wybierz jednolity kolor lub opisz nową scenę. AI wygeneruje nowe tło w sekundy. Idealne do zdjęć produktowych i profilowych. Darmowe kredyty na start.",
            "page": {
                "title1": "Darmowy AI Zmieniacz Tła Zdjęć",
                "title2": "Prześlij zdjęcie i wybierz sposób zmiany tła. Wybierz jednolity kolor, aby szybko uzyskać czyste tło do zdjęć produktowych lub profilowych, albo wpisz opis sceny, a AI wygeneruje nowe otoczenie wokół obiektu.",
                "faq": [
                    {
                        "question": "Jak zmienić tło zdjęcia za pomocą AI?",
                        "answer": "Prześlij zdjęcie, a następnie wybierz tryb tła. Wybierz jednolity kolor, jeśli chcesz czyste, proste tło, lub wpisz opis sceny, aby AI wygenerował nowe otoczenie. Kliknij Utwórz, aby przetworzyć obraz. Jeśli chcesz całkowicie usunąć tło, wypróbuj nasz <a href=\"/ai-image-background-remover\">Remover Tła</a>."
                    },
                    {
                        "question": "Czy mogę ustawić jednolite białe lub inne tło?",
                        "answer": "Tak. Użyj palety kolorów, aby wybrać biel, czerń lub dowolny kolor HEX. To idealne rozwiązanie do ofert produktowych, zdjęć profilowych i materiałów wymagających spójnego tła."
                    },
                    {
                        "question": "Czy mogę wygenerować nowe tło z opisu tekstowego?",
                        "answer": "Tak. Wpisz scenę, którą chcesz uzyskać — na przykład marmurowe studio, biurko w biurze, kącik kawiarni lub plaża o zachodzie słońca — a AI zastąpi oryginalne tło nowym otoczeniem wokół obiektu."
                    },
                    {
                        "question": "Kiedy wybrać tryb koloru, a kiedy tryb opisu?",
                        "answer": "Tryb koloru sprawdzi się, gdy potrzebujesz standardowych wyników — białego tła, tła w kolorze marki lub prostych zdjęć profilowych. Tryb opisu jest lepszy do tła lifestyle, marketingowego lub kreatywnego."
                    },
                    {
                        "question": "Czy mogę używać AI Zmieniacz Tła za darmo?",
                        "answer": "Tak. WeryAI przyznaje nowym użytkownikom darmowe kredyty przy rejestracji — bez karty kredytowej. Możesz też zdobywać kolejne darmowe kredyty poprzez codzienny check-in, wykonywanie zadań i zapraszanie znajomych, więc możesz korzystać z narzędzia bez płacenia z góry."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Jak zmienić tło zdjęcia za pomocą AI?",
                    "answer": "Prześlij zdjęcie, a następnie wybierz tryb tła. Wybierz jednolity kolor, jeśli chcesz czyste tło, lub wpisz opis sceny, aby AI wygenerował nowe otoczenie. Kliknij Utwórz, aby przetworzyć obraz."
                },
                {
                    "question": "Czy mogę ustawić jednolite białe lub inne tło?",
                    "answer": "Tak. Użyj palety kolorów, aby wybrać biel, czerń lub dowolny kolor HEX. To idealne rozwiązanie do ofert produktowych, zdjęć profilowych i materiałów w jednolitym stylu."
                },
                {
                    "question": "Czy mogę używać AI Zmieniacz Tła za darmo?",
                    "answer": "Tak. WeryAI przyznaje nowym użytkownikom darmowe kredyty przy rejestracji — bez karty kredytowej. Możesz też zdobywać kolejne darmowe kredyty poprzez codzienny check-in, wykonywanie zadań i zapraszanie znajomych."
                }
            ],
            "feature_title1": "Jednolite Tła do Produktów i Portretów",
            "feature_desc1": "Potrzebujesz czystego białego tła, czarnego lub w kolorze marki? Wybierz jednolity kolor, aby zamienić chaotyczne zdjęcia w schludne, ustandaryzowane obrazy do e-commerce, CV i profili.",
            "feature_title2": "Generowanie Scen z Opisu Tekstowego",
            "feature_desc2": "Opisz scenę — marmurowe studio, biurko, kącik kawiarni lub plażę o zachodzie słońca — a AI wygeneruje nowe tło wokół obiektu w kilka sekund.",
            "feature_title3": "Naturalne Zachowanie Obiektu",
            "feature_desc3": "WeryAI zachowuje wyrazistość głównego obiektu — osoby, zwierzęcia lub produktu — dzięki czemu wynik wygląda ostro i naturalnie po zmianie tła.",
            "howto": {
                "name": "Jak zmienić tło zdjęcia za pomocą AI",
                "step1": {
                    "name": "Prześlij zdjęcie",
                    "text": "Prześlij wyraźne zdjęcie produktu, portretu lub zwierzęcia do WeryAI."
                },
                "step2": {
                    "name": "Wybierz kolor lub wpisz opis",
                    "text": "Wybierz jednolity kolor tła lub wpisz opis nowej sceny. Używaj jednego trybu na raz."
                },
                "step3": {
                    "name": "Generuj",
                    "text": "Kliknij Utwórz. AI zachowa obiekt i zastąpi oryginalne tło w kilka sekund."
                }
            }
        }
    },
    "th": {
        "aiBackgroundChanger": {
            "title": "เปลี่ยนพื้นหลังรูปภาพด้วย AI ฟรี | WeryAI",
            "description": "เปลี่ยนพื้นหลังรูปภาพทันที — เลือกสีพื้นหลังเรียบหรืออธิบายฉากใหม่ด้วย AI เหมาะสำหรับรูปสินค้าและโปรไฟล์ เครดิตฟรี ไม่ต้องใช้บัตร",
            "keywords": "เปลี่ยนพื้นหลังรูป AI, เปลี่ยนพื้นหลังภาพ, พื้นหลังสีขาว, เปลี่ยนพื้นหลังออนไลน์, ลบพื้นหลัง AI, พื้นหลังรูปสินค้า, สร้างพื้นหลังใหม่",
            "og_title": "เปลี่ยนพื้นหลังรูปภาพด้วย AI ฟรี | WeryAI",
            "og_description": "เปลี่ยนพื้นหลังรูปภาพทันที — เลือกสีพื้นหลังเรียบหรืออธิบายฉากใหม่ด้วย AI เหมาะสำหรับรูปสินค้าและโปรไฟล์ เครดิตฟรี ไม่ต้องใช้บัตร",
            "twitter_title": "เปลี่ยนพื้นหลังรูปภาพด้วย AI ฟรี | WeryAI",
            "twitter_description": "เปลี่ยนพื้นหลังรูปภาพทันที — เลือกสีพื้นหลังเรียบหรืออธิบายฉากใหม่ด้วย AI เหมาะสำหรับรูปสินค้าและโปรไฟล์ เครดิตฟรี ไม่ต้องใช้บัตร",
            "page": {
                "title1": "เครื่องมือเปลี่ยนพื้นหลังรูปภาพ AI ฟรี",
                "title2": "อัปโหลดรูปภาพแล้วเลือกวิธีเปลี่ยนพื้นหลัง เลือกสีพื้นเรียบเพื่อสร้างพื้นหลังสะอาดสำหรับรูปสินค้าหรือโปรไฟล์ หรือพิมพ์คำอธิบายฉากเพื่อให้ AI สร้างสภาพแวดล้อมใหม่รอบวัตถุหลัก",
                "faq": [
                    {
                        "question": "เปลี่ยนพื้นหลังรูปด้วย AI ได้อย่างไร?",
                        "answer": "อัปโหลดรูปแล้วเลือกโหมดพื้นหลัง เลือกสีเรียบหากต้องการพื้นหลังสะอาด หรือพิมพ์คำอธิบายฉากเพื่อให้ AI สร้างสภาพแวดล้อมใหม่ คลิก สร้าง เพื่อประมวลผล หากต้องการลบพื้นหลังทั้งหมด ลองใช้ <a href=\"/ai-image-background-remover\">เครื่องมือลบพื้นหลัง</a>"
                    },
                    {
                        "question": "สามารถเปลี่ยนเป็นพื้นหลังสีขาวหรือสีเรียบอื่นได้ไหม?",
                        "answer": "ได้ ใช้ตัวเลือกสีเพื่อเลือกสีขาว ดำ หรือสี HEX ใดก็ได้ เหมาะสำหรับรูปสินค้าออนไลน์ รูปโปรไฟล์ และงานที่ต้องการพื้นหลังสม่ำเสมอ"
                    },
                    {
                        "question": "สามารถสร้างพื้นหลังใหม่จากข้อความได้ไหม?",
                        "answer": "ได้ พิมพ์ฉากที่ต้องการ เช่น สตูดิโอหินอ่อน โต๊ะทำงาน มุมร้านกาแฟ หรือชายหาดยามพระอาทิตย์ตก แล้ว AI จะสร้างพื้นหลังใหม่รอบวัตถุหลัก"
                    },
                    {
                        "question": "ควรใช้โหมดสีหรือโหมดคำอธิบายเมื่อไหร่?",
                        "answer": "ใช้โหมดสีเมื่อต้องการผลลัพธ์มาตรฐาน เช่น พื้นหลังสีขาว สีแบรนด์ หรือรูปโปรไฟล์เรียบง่าย ใช้โหมดคำอธิบายเมื่อต้องการพื้นหลังไลฟ์สไตล์ การตลาด หรือสร้างสรรค์"
                    },
                    {
                        "question": "สามารถใช้เครื่องมือเปลี่ยนพื้นหลัง AI ฟรีได้ไหม?",
                        "answer": "ได้ WeryAI มอบเครดิตฟรีให้ผู้ใช้ใหม่เมื่อสมัครสมาชิก ไม่ต้องใช้บัตรเครดิต นอกจากนี้ยังสามารถรับเครดิตฟรีเพิ่มได้จากการเช็กอินรายวัน ทำภารกิจ และเชิญเพื่อน จึงใช้งานเครื่องมือได้ต่อเนื่องโดยไม่ต้องจ่ายล่วงหน้า"
                    }
                ]
            },
            "faq": [
                {
                    "question": "เปลี่ยนพื้นหลังรูปด้วย AI ได้อย่างไร?",
                    "answer": "อัปโหลดรูปแล้วเลือกโหมดพื้นหลัง เลือกสีเรียบหากต้องการพื้นหลังสะอาด หรือพิมพ์คำอธิบายฉากเพื่อให้ AI สร้างสภาพแวดล้อมใหม่ คลิก สร้าง เพื่อประมวลผล"
                },
                {
                    "question": "สามารถเปลี่ยนเป็นพื้นหลังสีขาวหรือสีเรียบอื่นได้ไหม?",
                    "answer": "ได้ ใช้ตัวเลือกสีเพื่อเลือกสีขาว ดำ หรือสี HEX ใดก็ได้ เหมาะสำหรับรูปสินค้า รูปโปรไฟล์ และงานที่ต้องการพื้นหลังสม่ำเสมอ"
                },
                {
                    "question": "สามารถใช้เครื่องมือเปลี่ยนพื้นหลัง AI ฟรีได้ไหม?",
                    "answer": "ได้ WeryAI มอบเครดิตฟรีให้ผู้ใช้ใหม่เมื่อสมัครสมาชิก ไม่ต้องใช้บัตรเครดิต นอกจากนี้ยังรับเครดิตฟรีเพิ่มได้จากการเช็กอินรายวัน ทำภารกิจ และเชิญเพื่อน"
                }
            ],
            "feature_title1": "พื้นหลังสีเรียบสำหรับสินค้าและโปรไฟล์",
            "feature_desc1": "ต้องการพื้นหลังสีขาว ดำ หรือสีแบรนด์? เลือกสีเรียบเพื่อเปลี่ยนรูปที่มีพื้นหลังรก ให้เป็นรูปสะอาดมาตรฐานสำหรับอีคอมเมิร์ซ เรซูเม่ และโปรไฟล์",
            "feature_title2": "สร้างฉากจากคำอธิบายข้อความ",
            "feature_desc2": "อธิบายฉากที่ต้องการ เช่น สตูดิโอหินอ่อน โต๊ะทำงาน มุมร้านกาแฟ หรือชายหาดยามพระอาทิตย์ตก แล้ว AI จะสร้างพื้นหลังใหม่รอบวัตถุหลักในไม่กี่วินาที",
            "feature_title3": "รักษาวัตถุหลักอย่างเป็นธรรมชาติ",
            "feature_desc3": "WeryAI รักษาความชัดเจนของวัตถุหลัก ไม่ว่าจะเป็นคน สัตว์เลี้ยง หรือสินค้า เพื่อให้ผลลัพธ์ยังคงคมชัดและเป็นธรรมชาติหลังเปลี่ยนพื้นหลัง",
            "howto": {
                "name": "วิธีเปลี่ยนพื้นหลังรูปภาพด้วย AI",
                "step1": {
                    "name": "อัปโหลดรูปภาพ",
                    "text": "อัปโหลดรูปสินค้า พอร์ตเทรต หรือสัตว์เลี้ยงที่ชัดเจนไปยัง WeryAI"
                },
                "step2": {
                    "name": "เลือกสีหรือพิมพ์คำอธิบาย",
                    "text": "เลือกสีพื้นหลังเรียบ หรือพิมพ์คำอธิบายฉากใหม่ ใช้ทีละโหมด"
                },
                "step3": {
                    "name": "สร้าง",
                    "text": "คลิก สร้าง AI จะรักษาวัตถุหลักและเปลี่ยนพื้นหลังเดิมในไม่กี่วินาที"
                }
            }
        }
    },
    "da": {
        "aiBackgroundChanger": {
            "title": "Gratis AI Baggrundsskifter til Fotos | WeryAI",
            "description": "Skift fotobaggrunde øjeblikkeligt — vælg en ensfarvet baggrund eller beskriv en ny scene med AI. Perfekt til produktbilleder og profilfotos. Gratis credits, intet kort nødvendigt.",
            "keywords": "ai baggrundsskifter, skift fotobaggrund, hvid baggrund maker, erstat baggrund online, fjern baggrund AI, baggrundsgenerator AI",
            "og_title": "Gratis AI Baggrundsskifter til Fotos | WeryAI",
            "og_description": "Skift fotobaggrunde øjeblikkeligt — vælg en ensfarvet baggrund eller beskriv en ny scene med AI. Perfekt til produktbilleder og profilfotos. Gratis credits, intet kort nødvendigt.",
            "twitter_title": "Gratis AI Baggrundsskifter til Fotos | WeryAI",
            "twitter_description": "Skift fotobaggrunde øjeblikkeligt — vælg en ensfarvet baggrund eller beskriv en ny scene med AI. Perfekt til produktbilleder og profilfotos. Gratis credits, intet kort nødvendigt.",
            "page": {
                "title1": "Gratis AI Baggrundsskifter til Billeder",
                "title2": "Upload et foto og vælg, hvordan du vil skifte baggrunden. Vælg en ensfarvet baggrund for rene produkt- eller profilbilleder, eller indtast en beskrivelse, så AI genererer en helt ny scene omkring dit motiv.",
                "faq": [
                    {
                        "question": "Hvordan skifter jeg fotobaggrund med AI?",
                        "answer": "Upload dit billede, og vælg en baggrundstilstand. Vælg en ensfarvet farve for en ren, enkel baggrund, eller indtast en scenebeskrivelse, så AI genererer et nyt miljø. Klik Opret for at behandle det. Vil du fjerne baggrunden helt? Prøv vores <a href=\"/ai-image-background-remover\">Baggrundsfjerner</a>."
                    },
                    {
                        "question": "Kan jeg lave en ren hvid eller anden ensfarvet baggrund?",
                        "answer": "Ja. Brug farvevælgeren til at vælge hvid, sort eller enhver brugerdefineret HEX-farve. Det er ideelt til produktannoncer, profilfotos og andre outputs med standardiseret baggrund."
                    },
                    {
                        "question": "Kan jeg generere en ny baggrund fra tekst?",
                        "answer": "Ja. Skriv den scene, du ønsker — f.eks. et marmorstudie, et skrivebord, en caféhjørne eller en strand ved solnedgang — og AI erstatter den originale baggrund med en ny scene omkring dit motiv."
                    },
                    {
                        "question": "Hvornår skal jeg bruge farvetilstand frem for beskrivelsestilstand?",
                        "answer": "Brug farvetilstand, når du har brug for standardiserede resultater som hvide baggrunde, brand-farver eller enkle profilfotos. Brug beskrivelsestilstand til livsstils-, marketing- eller kreative scenebaggrunde."
                    },
                    {
                        "question": "Kan jeg bruge WeryAI AI Baggrundsskifter gratis?",
                        "answer": "Ja. WeryAI giver nye brugere gratis credits ved tilmelding uden kreditkort. Du kan også blive ved med at få gratis credits via dagligt check-in, fuldførte opgaver og invitation af venner, så du kan fortsætte med at bruge værktøjet uden at betale på forhånd."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hvordan skifter jeg fotobaggrund med AI?",
                    "answer": "Upload dit billede, og vælg en baggrundstilstand. Vælg en ensfarvet farve for en ren baggrund, eller indtast en scenebeskrivelse, så AI genererer et nyt miljø. Klik Opret for at behandle."
                },
                {
                    "question": "Kan jeg lave en ren hvid eller anden ensfarvet baggrund?",
                    "answer": "Ja. Brug farvevælgeren til at vælge hvid, sort eller enhver HEX-farve. Ideelt til produktannoncer, profilfotos og standardiserede billeder."
                },
                {
                    "question": "Kan jeg bruge WeryAI AI Baggrundsskifter gratis?",
                    "answer": "Ja. WeryAI giver nye brugere gratis credits ved tilmelding uden kreditkort. Du kan også få gratis credits via dagligt check-in, opgaver og invitation af venner."
                }
            ],
            "feature_title1": "Ensfarvede Baggrunde til Produkter og Portrætter",
            "feature_desc1": "Har du brug for en ren hvid baggrund, sort eller en brandfarve? Vælg en ensfarvet farve for at forvandle rodede fotos til rene, standardiserede billeder til e-handel, CV og profiler.",
            "feature_title2": "Sceneskift via Tekstbeskrivelse",
            "feature_desc2": "Beskriv den scene, du ønsker — et marmorstudie, et skrivebord, en caféhjørne eller en strand ved solnedgang — og AI genererer en ny baggrund omkring dit motiv på sekunder.",
            "feature_title3": "Naturlig Bevarelse af Motivet",
            "feature_desc3": "WeryAI bevarer hovedmotivet — person, kæledyr eller produkt — skarpt og tydeligt, så resultatet stadig ser fokuseret og brugbart ud efter baggrundsskiftet.",
            "howto": {
                "name": "Sådan skifter du fotobaggrund med AI",
                "step1": {
                    "name": "Upload billede",
                    "text": "Upload et tydeligt produkt-, portræt- eller kæledyrsfoto til WeryAI."
                },
                "step2": {
                    "name": "Vælg farve eller beskriv scene",
                    "text": "Vælg en ensfarvet baggrundsfarve, eller skriv en beskrivelse af en ny scene. Brug én tilstand ad gangen."
                },
                "step3": {
                    "name": "Generer",
                    "text": "Klik Opret. AI bevarer motivet og erstatter den originale baggrund på sekunder."
                }
            }
        }
    },
    "no": {
        "aiBackgroundChanger": {
            "title": "Gratis AI Bakgrunnsbytter for Bilder | WeryAI",
            "description": "Endre bildebakgrunner umiddelbart — velg en ensfarget bakgrunn eller beskriv en ny scene med AI. Perfekt for produktbilder og profilbilder. Gratis kreditter, uten kort.",
            "keywords": "ai bakgrunnsbytter, endre bildebakgrunn, hvit bakgrunn, bytt bakgrunn online, fjern bakgrunn AI, bakgrunnsgenerator AI",
            "og_title": "Gratis AI Bakgrunnsbytter for Bilder | WeryAI",
            "og_description": "Endre bildebakgrunner umiddelbart — velg en ensfarget bakgrunn eller beskriv en ny scene med AI. Perfekt for produktbilder og profilbilder. Gratis kreditter, uten kort.",
            "twitter_title": "Gratis AI Bakgrunnsbytter for Bilder | WeryAI",
            "twitter_description": "Endre bildebakgrunner umiddelbart — velg en ensfarget bakgrunn eller beskriv en ny scene med AI. Perfekt for produktbilder og profilbilder. Gratis kreditter, uten kort.",
            "page": {
                "title1": "Gratis AI Bakgrunnsbytter for Bilder",
                "title2": "Last opp et bilde og velg hvordan du vil endre bakgrunnen. Velg en ensfarget bakgrunn for rene produkt- eller profilbilder, eller skriv en beskrivelse slik at AI genererer en helt ny scene rundt motivet ditt.",
                "faq": [
                    {
                        "question": "Hvordan endrer jeg bildebakgrunn med AI?",
                        "answer": "Last opp bildet ditt og velg en bakgrunnsmodus. Velg en ensfarget farge for en ren, enkel bakgrunn, eller skriv en scenebeskrivelse slik at AI genererer et nytt miljø. Klikk Opprett for å behandle det. Vil du fjerne bakgrunnen helt? Prøv vår <a href=\"/ai-image-background-remover\">Bakgrunnsfjerning</a>."
                    },
                    {
                        "question": "Kan jeg lage en ren hvit eller annen ensfarget bakgrunn?",
                        "answer": "Ja. Bruk fargevelgeren til å velge hvit, svart eller en egendefinert HEX-farge. Det er perfekt for produktannonser, profilbilder og annet standardisert innhold."
                    },
                    {
                        "question": "Kan jeg generere en ny bakgrunn fra tekst?",
                        "answer": "Ja. Skriv scenen du ønsker — for eksempel et marmorstudio, et skrivebord, et kaféhjørne eller en strand ved solnedgang — og AI erstatter den opprinnelige bakgrunnen med en ny scene rundt motivet."
                    },
                    {
                        "question": "Når bør jeg bruke fargemodus i stedet for beskrivelsesmodus?",
                        "answer": "Bruk fargemodus når du trenger standardiserte resultater som hvite bakgrunner, merkefarger eller enkle profilbilder. Bruk beskrivelsesmodus til livsstils-, markedsførings- eller kreative scenebakgrunner."
                    },
                    {
                        "question": "Kan jeg bruke WeryAI AI Bakgrunnsbytter gratis?",
                        "answer": "Ja. WeryAI gir nye brukere gratis kreditter ved registrering uten kredittkort. Du kan også fortsette å få gratis kreditter gjennom daglig innsjekking, fullførte oppgaver og invitasjon av venner, slik at du kan fortsette å bruke verktøyet uten å betale på forhånd."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hvordan endrer jeg bildebakgrunn med AI?",
                    "answer": "Last opp bildet ditt og velg en bakgrunnsmodus. Velg en ensfarget farge for en ren bakgrunn, eller skriv en scenebeskrivelse. Klikk Opprett for å behandle bildet."
                },
                {
                    "question": "Kan jeg lage en ren hvit eller annen ensfarget bakgrunn?",
                    "answer": "Ja. Bruk fargevelgeren til å velge hvit, svart eller en egendefinert HEX-farge. Perfekt for produktannonser, profilbilder og standardisert innhold."
                },
                {
                    "question": "Kan jeg bruke WeryAI AI Bakgrunnsbytter gratis?",
                    "answer": "Ja. WeryAI gir nye brukere gratis kreditter ved registrering uten kredittkort. Du kan også få gratis kreditter gjennom daglig innsjekking, oppgaver og invitasjon av venner."
                }
            ],
            "feature_title1": "Ensfargede Bakgrunner for Produkter og Portretter",
            "feature_desc1": "Trenger du en ren hvit bakgrunn, svart eller en merkefarge? Velg en ensfarget farge for å forvandle rotete bilder til rene, standardiserte bilder for netthandel, CV og profiler.",
            "feature_title2": "Scenegenerering fra Tekstbeskrivelse",
            "feature_desc2": "Beskriv scenen du ønsker — et marmorstudio, et skrivebord, et kaféhjørne eller en strand ved solnedgang — og AI genererer en ny bakgrunn rundt motivet på sekunder.",
            "feature_title3": "Naturlig Bevaring av Motivet",
            "feature_desc3": "WeryAI bevarer hovedmotivet — person, kjæledyr eller produkt — skarpt og tydelig, slik at resultatet ser fokusert og brukbart ut etter bakgrunnsbyttet.",
            "howto": {
                "name": "Slik endrer du bildebakgrunn med AI",
                "step1": {
                    "name": "Last opp bilde",
                    "text": "Last opp et tydelig produkt-, portrett- eller kjæledyrsbilde til WeryAI."
                },
                "step2": {
                    "name": "Velg farge eller beskriv scene",
                    "text": "Velg en ensfarget bakgrunnsfarge, eller skriv en beskrivelse av en ny scene. Bruk én modus om gangen."
                },
                "step3": {
                    "name": "Generer",
                    "text": "Klikk Opprett. AI bevarer motivet og erstatter den opprinnelige bakgrunnen på sekunder."
                }
            }
        }
    },
    "nl": {
        "aiBackgroundChanger": {
            "title": "Gratis AI Achtergrondwisselaar voor Foto's | WeryAI",
            "description": "Verander fotoachtergronden direct — kies een effen kleur of beschrijf een nieuwe scène met AI. Ideaal voor productfoto's en profielfoto's. Gratis credits, geen kaart nodig.",
            "keywords": "ai achtergrondwisselaar, achtergrond wijzigen foto, witte achtergrond maker, achtergrond vervangen online, achtergrond verwijderen AI, achtergrondgenerator",
            "og_title": "Gratis AI Achtergrondwisselaar voor Foto's | WeryAI",
            "og_description": "Verander fotoachtergronden direct — kies een effen kleur of beschrijf een nieuwe scène met AI. Ideaal voor productfoto's en profielfoto's. Gratis credits, geen kaart nodig.",
            "twitter_title": "Gratis AI Achtergrondwisselaar voor Foto's | WeryAI",
            "twitter_description": "Verander fotoachtergronden direct — kies een effen kleur of beschrijf een nieuwe scène met AI. Ideaal voor productfoto's en profielfoto's. Gratis credits, geen kaart nodig.",
            "page": {
                "title1": "Gratis AI Achtergrondwisselaar voor Foto's",
                "title2": "Upload een foto en kies hoe je de achtergrond wilt veranderen. Kies een effen kleur voor schone product- of profielfoto's, of typ een beschrijving zodat AI een geheel nieuwe scène rondom je onderwerp genereert.",
                "faq": [
                    {
                        "question": "Hoe verander ik een fotoachtergrond met AI?",
                        "answer": "Upload je afbeelding en kies een achtergrondmodus. Kies een effen kleur voor een schone, eenvoudige achtergrond, of typ een scènebeschrijving zodat AI een nieuwe omgeving genereert. Klik op Maken om te verwerken. Wil je de achtergrond volledig verwijderen? Probeer onze <a href=\"/ai-image-background-remover\">Achtergrondverwijderaar</a>."
                    },
                    {
                        "question": "Kan ik een effen witte of andere achtergrond instellen?",
                        "answer": "Ja. Gebruik de kleurkiezer om wit, zwart of een aangepaste HEX-kleur te kiezen. Dit is ideaal voor productadvertenties, profielfoto's en ander gestandaardiseerd beeldmateriaal."
                    },
                    {
                        "question": "Kan ik een nieuwe achtergrond genereren vanuit tekst?",
                        "answer": "Ja. Typ de scène die je wilt — bijvoorbeeld een marmeren studio, een bureau, een caféhoek of een strand bij zonsondergang — en AI vervangt de originele achtergrond door een nieuwe scène rondom je onderwerp."
                    },
                    {
                        "question": "Wanneer gebruik ik kleurmodus in plaats van beschrijvingsmodus?",
                        "answer": "Gebruik kleurmodus wanneer je gestandaardiseerde resultaten nodig hebt, zoals witte achtergronden, merkkleuren of eenvoudige profielfoto's. Gebruik beschrijvingsmodus voor lifestyle-, marketing- of creatieve scèneachtergronden."
                    },
                    {
                        "question": "Kan ik WeryAI AI Achtergrondwisselaar gratis gebruiken?",
                        "answer": "Ja. WeryAI geeft nieuwe gebruikers gratis credits bij registratie zonder creditcard. Je kunt ook gratis credits blijven verdienen via dagelijkse check-ins, het voltooien van taken en het uitnodigen van vrienden, zodat je de tool kunt blijven gebruiken zonder vooraf te betalen."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hoe verander ik een fotoachtergrond met AI?",
                    "answer": "Upload je afbeelding en kies een achtergrondmodus. Kies een effen kleur voor een schone achtergrond, of typ een scènebeschrijving. Klik op Maken om te verwerken."
                },
                {
                    "question": "Kan ik een effen witte of andere achtergrond instellen?",
                    "answer": "Ja. Gebruik de kleurkiezer om wit, zwart of een aangepaste HEX-kleur te kiezen. Ideaal voor productadvertenties, profielfoto's en gestandaardiseerd beeldmateriaal."
                },
                {
                    "question": "Kan ik WeryAI AI Achtergrondwisselaar gratis gebruiken?",
                    "answer": "Ja. WeryAI geeft nieuwe gebruikers gratis credits bij registratie zonder creditcard. Je kunt ook gratis credits verdienen via dagelijkse check-ins, taken en het uitnodigen van vrienden."
                }
            ],
            "feature_title1": "Effen Achtergronden voor Producten en Portretten",
            "feature_desc1": "Heb je een schone witte achtergrond, zwart of een merkkleur nodig? Kies een effen kleur om rommelige foto's om te zetten in nette, gestandaardiseerde afbeeldingen voor e-commerce, cv's en profielen.",
            "feature_title2": "Scènevervanging via Tekstbeschrijving",
            "feature_desc2": "Beschrijf de scène die je wilt — een marmeren studio, een bureau, een caféhoek of een strand bij zonsondergang — en AI genereert een nieuwe achtergrond rondom je onderwerp in seconden.",
            "feature_title3": "Natuurlijk Behoud van het Onderwerp",
            "feature_desc3": "WeryAI houdt het hoofdonderwerp — persoon, huisdier of product — scherp en duidelijk, zodat het resultaat er nog steeds gefocust en bruikbaar uitziet na de achtergrondwissel.",
            "howto": {
                "name": "Zo verander je een fotoachtergrond met AI",
                "step1": {
                    "name": "Upload afbeelding",
                    "text": "Upload een duidelijke product-, portret- of huisdierfoto naar WeryAI."
                },
                "step2": {
                    "name": "Kies kleur of beschrijf scène",
                    "text": "Kies een effen achtergrondkleur, of typ een beschrijving van een nieuwe scène. Gebruik één modus tegelijk."
                },
                "step3": {
                    "name": "Genereren",
                    "text": "Klik op Maken. AI behoudt het onderwerp en vervangt de originele achtergrond in seconden."
                }
            }
        }
    },
    "id": {
        "aiBackgroundChanger": {
            "title": "Pengubah Latar Belakang Foto AI Gratis Online | WeryAI",
            "description": "Ubah latar belakang foto secara instan — pilih warna solid atau deskripsikan adegan baru dengan AI. Sempurna untuk foto produk dan profil. Kredit gratis, tanpa kartu.",
            "keywords": "pengubah latar belakang AI, ubah latar belakang foto, latar belakang putih, ganti latar belakang online, hapus latar belakang AI, generator latar belakang AI",
            "og_title": "Pengubah Latar Belakang Foto AI Gratis Online | WeryAI",
            "og_description": "Ubah latar belakang foto secara instan — pilih warna solid atau deskripsikan adegan baru dengan AI. Sempurna untuk foto produk dan profil. Kredit gratis, tanpa kartu.",
            "twitter_title": "Pengubah Latar Belakang Foto AI Gratis Online | WeryAI",
            "twitter_description": "Ubah latar belakang foto secara instan — pilih warna solid atau deskripsikan adegan baru dengan AI. Sempurna untuk foto produk dan profil. Kredit gratis, tanpa kartu.",
            "page": {
                "title1": "Pengubah Latar Belakang Foto AI Gratis",
                "title2": "Unggah foto dan pilih cara mengganti latar belakang. Pilih warna solid untuk membuat latar belakang bersih pada foto produk atau profil, atau ketik deskripsi adegan agar AI membuat lingkungan baru di sekitar subjek Anda.",
                "faq": [
                    {
                        "question": "Bagaimana cara mengubah latar belakang foto dengan AI?",
                        "answer": "Unggah gambar Anda, lalu pilih mode latar belakang. Pilih warna solid jika ingin latar belakang polos yang bersih, atau ketik deskripsi adegan agar AI menghasilkan lingkungan baru. Klik Buat untuk memproses. Ingin menghapus latar belakang sepenuhnya? Coba <a href=\"/ai-image-background-remover\">Penghapus Latar Belakang</a> kami."
                    },
                    {
                        "question": "Bisakah saya membuat latar belakang putih polos atau warna solid lainnya?",
                        "answer": "Bisa. Gunakan pemilih warna untuk memilih putih, hitam, atau warna HEX kustom apa pun. Ini ideal untuk iklan produk, foto profil, dan konten visual yang terstandarisasi."
                    },
                    {
                        "question": "Bisakah saya membuat latar belakang baru dari teks?",
                        "answer": "Bisa. Ketik adegan yang Anda inginkan — misalnya studio marmer, meja kantor, sudut kafe, atau pantai saat matahari terbenam — dan AI akan mengganti latar belakang asli dengan adegan baru di sekitar subjek."
                    },
                    {
                        "question": "Kapan sebaiknya menggunakan mode warna dan kapan mode deskripsi?",
                        "answer": "Gunakan mode warna jika membutuhkan hasil standar seperti latar belakang putih, warna merek, atau foto profil sederhana. Gunakan mode deskripsi untuk latar belakang gaya hidup, pemasaran, atau kreatif."
                    },
                    {
                        "question": "Bisakah saya menggunakan WeryAI Pengubah Latar Belakang AI secara gratis?",
                        "answer": "Bisa. WeryAI memberikan kredit gratis kepada pengguna baru saat mendaftar tanpa kartu kredit. Anda juga bisa terus mendapatkan kredit gratis melalui check-in harian, menyelesaikan tugas, dan mengundang teman, sehingga Anda dapat terus menggunakan alat ini tanpa membayar di muka."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Bagaimana cara mengubah latar belakang foto dengan AI?",
                    "answer": "Unggah gambar Anda, lalu pilih mode latar belakang. Pilih warna solid untuk latar belakang bersih, atau ketik deskripsi adegan. Klik Buat untuk memproses."
                },
                {
                    "question": "Bisakah saya membuat latar belakang putih polos atau warna solid lainnya?",
                    "answer": "Bisa. Gunakan pemilih warna untuk memilih putih, hitam, atau warna HEX kustom. Ideal untuk iklan produk, foto profil, dan konten visual standar."
                },
                {
                    "question": "Bisakah saya menggunakan WeryAI Pengubah Latar Belakang AI secara gratis?",
                    "answer": "Bisa. WeryAI memberikan kredit gratis kepada pengguna baru saat mendaftar tanpa kartu kredit. Anda juga bisa mendapatkan kredit gratis melalui check-in harian, tugas, dan mengundang teman."
                }
            ],
            "feature_title1": "Latar Belakang Solid untuk Produk dan Potret",
            "feature_desc1": "Butuh latar belakang putih bersih, hitam, atau warna merek? Pilih warna solid untuk mengubah foto berantakan menjadi gambar rapi dan terstandarisasi untuk e-commerce, CV, dan profil.",
            "feature_title2": "Pembuatan Adegan dari Deskripsi Teks",
            "feature_desc2": "Deskripsikan adegan yang Anda inginkan — studio marmer, meja kantor, sudut kafe, atau pantai saat matahari terbenam — dan AI akan menghasilkan latar belakang baru di sekitar subjek dalam hitungan detik.",
            "feature_title3": "Pelestarian Subjek yang Alami",
            "feature_desc3": "WeryAI menjaga subjek utama — orang, hewan peliharaan, atau produk — tetap tajam dan jelas, sehingga hasil masih terlihat fokus dan dapat digunakan setelah perubahan latar belakang.",
            "howto": {
                "name": "Cara Mengubah Latar Belakang Foto dengan AI",
                "step1": {
                    "name": "Unggah Gambar",
                    "text": "Unggah foto produk, potret, atau hewan peliharaan yang jelas ke WeryAI."
                },
                "step2": {
                    "name": "Pilih Warna atau Ketik Deskripsi",
                    "text": "Pilih warna latar belakang solid, atau ketik deskripsi adegan baru. Gunakan satu mode sekaligus."
                },
                "step3": {
                    "name": "Hasilkan",
                    "text": "Klik Buat. AI akan mempertahankan subjek dan mengganti latar belakang asli dalam hitungan detik."
                }
            }
        }
    },
    "tr": {
        "aiBackgroundChanger": {
            "title": "Ücretsiz AI Fotoğraf Arka Plan Değiştirici | WeryAI",
            "description": "Fotoğraf arka planlarını anında değiştirin — düz renk seçin veya AI ile yeni bir sahne tanımlayın. Ürün ve profil fotoğrafları için ideal. Ücretsiz kredi, kart gerekmez.",
            "keywords": "yapay zeka arka plan değiştirici, fotoğraf arka planı değiştirme, beyaz arka plan yapıcı, arka plan değiştirme online, arka plan kaldırma AI, arka plan oluşturucu AI",
            "og_title": "Ücretsiz AI Fotoğraf Arka Plan Değiştirici | WeryAI",
            "og_description": "Fotoğraf arka planlarını anında değiştirin — düz renk seçin veya AI ile yeni bir sahne tanımlayın. Ürün ve profil fotoğrafları için ideal. Ücretsiz kredi, kart gerekmez.",
            "twitter_title": "Ücretsiz AI Fotoğraf Arka Plan Değiştirici | WeryAI",
            "twitter_description": "Fotoğraf arka planlarını anında değiştirin — düz renk seçin veya AI ile yeni bir sahne tanımlayın. Ürün ve profil fotoğrafları için ideal. Ücretsiz kredi, kart gerekmez.",
            "page": {
                "title1": "Ücretsiz AI Fotoğraf Arka Plan Değiştirici",
                "title2": "Bir fotoğraf yükleyin ve arka planı nasıl değiştirmek istediğinizi seçin. Temiz ürün veya profil fotoğrafları için düz renk seçin ya da bir sahne açıklaması yazarak AI'ın konunuzun etrafında yepyeni bir ortam oluşturmasını sağlayın.",
                "faq": [
                    {
                        "question": "AI ile fotoğraf arka planını nasıl değiştiririm?",
                        "answer": "Görüntünüzü yükleyin ve bir arka plan modu seçin. Temiz, sade bir arka plan istiyorsanız düz renk seçin veya AI'ın yeni bir ortam oluşturması için sahne açıklaması yazın. İşlemek için Oluştur'a tıklayın. Arka planı tamamen kaldırmak ister misiniz? <a href=\"/ai-image-background-remover\">Arka Plan Kaldırma</a> aracımızı deneyin."
                    },
                    {
                        "question": "Düz beyaz veya başka bir renk arka plan yapabilir miyim?",
                        "answer": "Evet. Renk seçiciyi kullanarak beyaz, siyah veya herhangi bir HEX rengini seçin. Bu, ürün ilanları, profil fotoğrafları ve standartlaştırılmış görsel içerik için idealdir."
                    },
                    {
                        "question": "Metinden yeni bir arka plan oluşturabilir miyim?",
                        "answer": "Evet. İstediğiniz sahneyi yazın — örneğin mermer stüdyo, ofis masası, kafe köşesi veya gün batımında sahil — ve AI orijinal arka planı konunuzun etrafında yeni bir sahneyle değiştirir."
                    },
                    {
                        "question": "Renk modunu mu yoksa açıklama modunu mu kullanmalıyım?",
                        "answer": "Beyaz arka plan, marka renkleri veya basit profil fotoğrafları gibi standart sonuçlara ihtiyacınız varsa renk modunu kullanın. Yaşam tarzı, pazarlama veya yaratıcı sahne arka planları için açıklama modunu kullanın."
                    },
                    {
                        "question": "WeryAI AI Arka Plan Değiştirici'yi ücretsiz kullanabilir miyim?",
                        "answer": "Evet. WeryAI yeni kullanıcılara kayıt sırasında kredi kartı gerekmeden ücretsiz krediler verir. Ayrıca günlük giriş, görev tamamlama ve arkadaş davetleri yoluyla ücretsiz kredi kazanmaya devam edebilirsiniz; böylece aracı ön ödeme yapmadan kullanmayı sürdürebilirsiniz."
                    }
                ]
            },
            "faq": [
                {
                    "question": "AI ile fotoğraf arka planını nasıl değiştiririm?",
                    "answer": "Görüntünüzü yükleyin ve bir arka plan modu seçin. Temiz bir arka plan için düz renk seçin veya sahne açıklaması yazın. İşlemek için Oluştur'a tıklayın."
                },
                {
                    "question": "Düz beyaz veya başka bir renk arka plan yapabilir miyim?",
                    "answer": "Evet. Renk seçiciyi kullanarak beyaz, siyah veya herhangi bir HEX rengini seçin. Ürün ilanları, profil fotoğrafları ve standart görseller için idealdir."
                },
                {
                    "question": "WeryAI AI Arka Plan Değiştirici'yi ücretsiz kullanabilir miyim?",
                    "answer": "Evet. WeryAI yeni kullanıcılara kayıt sırasında kredi kartı gerekmeden ücretsiz krediler verir. Günlük giriş, görevler ve arkadaş davetleri ile de ücretsiz kredi kazanabilirsiniz."
                }
            ],
            "feature_title1": "Ürünler ve Portreler için Düz Renkli Arka Planlar",
            "feature_desc1": "Temiz bir beyaz arka plan, siyah veya marka rengi mi gerekiyor? Düz renk seçerek dağınık fotoğrafları e-ticaret, CV ve profiller için düzenli, standart görüntülere dönüştürün.",
            "feature_title2": "Metin Açıklamasından Sahne Oluşturma",
            "feature_desc2": "İstediğiniz sahneyi tanımlayın — mermer stüdyo, ofis masası, kafe köşesi veya gün batımında sahil — ve AI konunuzun etrafında saniyeler içinde yeni bir arka plan oluşturur.",
            "feature_title3": "Doğal Konu Koruma",
            "feature_desc3": "WeryAI ana konuyu — kişi, evcil hayvan veya ürün — net ve keskin tutar, böylece sonuç arka plan değişikliğinden sonra bile odaklı ve kullanılabilir görünür.",
            "howto": {
                "name": "AI ile Fotoğraf Arka Planı Nasıl Değiştirilir",
                "step1": {
                    "name": "Görüntü Yükle",
                    "text": "Temiz bir ürün, portre veya evcil hayvan fotoğrafını WeryAI'ye yükleyin."
                },
                "step2": {
                    "name": "Renk Seç veya Açıklama Yaz",
                    "text": "Düz bir arka plan rengi seçin veya yeni bir sahne açıklaması yazın. Bir seferde tek mod kullanın."
                },
                "step3": {
                    "name": "Oluştur",
                    "text": "Oluştur'a tıklayın. AI konuyu korur ve orijinal arka planı saniyeler içinde değiştirir."
                }
            }
        }
    }
}
